export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export enum AccountStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Suspended = 'suspended'
}

export type AdditionalSection = {
  __typename?: 'AdditionalSection';
  content?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AdditionalSectionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  state: Scalars['String']['output'];
  streetAddress1: Scalars['String']['output'];
  streetAddress2?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  state: Scalars['String']['input'];
  streetAddress1: Scalars['String']['input'];
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export enum AdminPermission {
  All = 'All',
  Analytics = 'Analytics',
  ContentManagement = 'ContentManagement',
  Reports = 'Reports',
  SystemSettings = 'SystemSettings',
  UserManagement = 'UserManagement'
}

export enum AdminRole {
  Admin = 'Admin',
  Moderator = 'Moderator',
  SuperAdmin = 'SuperAdmin'
}

export type AdminUser = {
  __typename?: 'AdminUser';
  _id: Scalars['ID']['output'];
  accountType?: Maybe<UserAccountType>;
  createdAt?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  password: Scalars['String']['output'];
  permissions?: Maybe<Array<Maybe<AdminPermission>>>;
  role?: Maybe<AdminRole>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum AgeRange {
  FiftyFiveToSixtyFive = 'fiftyFiveToSixtyFive',
  FortyFiveToFiftyFive = 'fortyFiveToFiftyFive',
  SixtyFiveAndUp = 'sixtyFiveAndUp',
  ThirtyFiveToFortyFive = 'thirtyFiveToFortyFive',
  TwentyFiveToThirtyFive = 'twentyFiveToThirtyFive',
  UnderTwentyFive = 'underTwentyFive'
}

export type AliasGenerationResult = {
  __typename?: 'AliasGenerationResult';
  aliasId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum AnnualProjectCapacity {
  ElevenAndUp = 'ElevenAndUp',
  FourToSix = 'FourToSix',
  OneToThree = 'OneToThree',
  SevenToTen = 'SevenToTen'
}

export type ApplicationBusinessGoalsOverview = {
  numberOfProjectsCurrentYear?: InputMaybe<Scalars['Int']['input']>;
  numberOfProjectsLastYear?: InputMaybe<Scalars['Int']['input']>;
  totalRevenueCurrentYear?: InputMaybe<Scalars['String']['input']>;
  totalRevenueLastYear?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationBusinessGoalsProjectCapacity = {
  largeScale?: InputMaybe<AnnualProjectCapacity>;
  smallScale?: InputMaybe<AnnualProjectCapacity>;
};

export type ApplicationExperience = {
  company?: InputMaybe<Scalars['String']['input']>;
  current?: InputMaybe<Scalars['Boolean']['input']>;
  employmentType?: InputMaybe<EmploymentType>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  firmSize?: InputMaybe<FirmSize>;
  id?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationReference = {
  ProjectType?: InputMaybe<ReferenceProjectType>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReferenceType>;
  yearsKnown?: InputMaybe<Scalars['Int']['input']>;
};

export enum AquisitionPreferences {
  ClientContribution = 'clientContribution',
  DesignerControlled = 'designerControlled',
  Hybrid = 'hybrid'
}

export type AquisitionRanking = {
  __typename?: 'AquisitionRanking';
  acquisitionPreference?: Maybe<AquisitionPreferences>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type AquisitionRankingInput = {
  acquisitionPreference?: InputMaybe<AquisitionPreferences>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
};

export type BeforeAndAfterProject = {
  __typename?: 'BeforeAndAfterProject';
  _id: Scalars['ID']['output'];
  additionalSections?: Maybe<Array<Maybe<AdditionalSection>>>;
  afterImage?: Maybe<Scalars['ID']['output']>;
  afterImages?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  beforeImage?: Maybe<Scalars['ID']['output']>;
  beforeImages?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  budgetRange?: Maybe<BudgetRange>;
  challenges?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<Scalars['ID']['output']>;
  featuredOnBio?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  projectCategory?: Maybe<ProjectCategory>;
  projectDuration?: Maybe<ProjectDuration>;
  shareToken?: Maybe<Scalars['String']['output']>;
  specialRequirements?: Maybe<Array<Maybe<SpecialRequirements>>>;
  squareFootage?: Maybe<SquareFootage>;
  storySubtitle?: Maybe<Scalars['String']['output']>;
  storyTitle?: Maybe<Scalars['String']['output']>;
  style?: Maybe<ProjectStyles>;
  wishList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum BillingCycle {
  Annual = 'annual',
  Free = 'free',
  Monthly = 'monthly'
}

export type BillingInfo = {
  __typename?: 'BillingInfo';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type BillingInfoInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export enum BudgetRange {
  From_3001To_5Hundred = 'FROM_3001_TO_5_HUNDRED',
  From_5001To_10Thousand = 'FROM_5001_TO_10_THOUSAND',
  From_10001To_15Thousand = 'FROM_10001_TO_15_THOUSAND',
  From_15001To_20Thousand = 'FROM_15001_TO_20_THOUSAND',
  From_20001To_25Thousand = 'FROM_20001_TO_25_THOUSAND',
  From_25001To_30Thousand = 'FROM_25001_TO_30_THOUSAND',
  From_30001To_35Thousand = 'FROM_30001_TO_35_THOUSAND',
  From_35001To_40Thousand = 'FROM_35001_TO_40_THOUSAND',
  From_40001To_45Thousand = 'FROM_40001_TO_45_THOUSAND',
  From_45001To_50Thousand = 'FROM_45001_TO_50_THOUSAND',
  FifteenKToTwentyK = 'FifteenKToTwentyK',
  FiftyKToSeventyFiveK = 'FiftyKToSeventyFiveK',
  FiveKToTenK = 'FiveKToTenK',
  FortyKToFiftyK = 'FortyKToFiftyK',
  OneHundredKAndUp = 'OneHundredKAndUp',
  SeventyFiveKToOneHundredK = 'SeventyFiveKToOneHundredK',
  TenKToFifteenK = 'TenKToFifteenK',
  ThirtyKToFortyK = 'ThirtyKToFortyK',
  ThreeKToFiveK = 'ThreeKToFiveK',
  TwentyKToThirtyK = 'TwentyKToThirtyK',
  Under_3000 = 'UNDER_3000',
  UpToThreeK = 'upToThreeK'
}

export type BusinessGoals = {
  __typename?: 'BusinessGoals';
  challenges?: Maybe<Scalars['String']['output']>;
  expectations?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<BusinessGoalsOverview>;
  projectCapacity?: Maybe<BusinessGoalsProjectCapacity>;
};

export type BusinessGoalsOverview = {
  __typename?: 'BusinessGoalsOverview';
  numberOfProjectsCurrentYear?: Maybe<Scalars['Int']['output']>;
  numberOfProjectsLastYear?: Maybe<Scalars['Int']['output']>;
  totalRevenueCurrentYear?: Maybe<Scalars['String']['output']>;
  totalRevenueLastYear?: Maybe<Scalars['String']['output']>;
};

export type BusinessGoalsProjectCapacity = {
  __typename?: 'BusinessGoalsProjectCapacity';
  largeScale?: Maybe<AnnualProjectCapacity>;
  smallScale?: Maybe<AnnualProjectCapacity>;
};

export enum ColorFamily {
  Aqua = 'Aqua',
  Black = 'Black',
  Blue = 'Blue',
  Brown = 'Brown',
  Cyan = 'Cyan',
  Denim = 'Denim',
  Gold = 'Gold',
  Green = 'Green',
  Grey = 'Grey',
  Lime = 'Lime',
  Maroon = 'Maroon',
  Navy = 'Navy',
  Orange = 'Orange',
  Pink = 'Pink',
  Purple = 'Purple',
  Red = 'Red',
  Tan = 'Tan',
  Teal = 'Teal',
  Turquoise = 'Turquoise',
  Violet = 'Violet',
  White = 'White',
  Yellow = 'Yellow'
}

export enum CommunicationPreference {
  Email = 'Email',
  Phone = 'Phone',
  Text = 'Text'
}

export enum CompensationModel {
  CostPlusMarkup = 'costPlusMarkup',
  FlatFee = 'flatFee',
  Hourly = 'hourly',
  Hybrid = 'hybrid',
  PercentageOfCost = 'percentageOfCost',
  Retainer = 'retainer',
  SquareFootage = 'squareFootage'
}

export enum CompetencyLevel {
  Basic = 'Basic',
  None = 'None',
  Pro = 'Pro'
}

export type CompletionDataInput = {
  certificateUrl?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type CourseCompletionResponse = {
  __typename?: 'CourseCompletionResponse';
  message: Scalars['String']['output'];
  nextStep?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CourseEnrollment = {
  __typename?: 'CourseEnrollment';
  certificateUrl?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['String']['output']>;
  courseId: Scalars['String']['output'];
  crmWebhookUrl?: Maybe<Scalars['String']['output']>;
  enrolledAt: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
  status: Scalars['String']['output'];
};

export type CourseEnrollmentResponse = {
  __typename?: 'CourseEnrollmentResponse';
  courseUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type CreatePaymentInput = {
  contactEmail: Scalars['String']['input'];
  contactId?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  paymentAmount: Scalars['Float']['input'];
  paymentCurrency?: InputMaybe<Scalars['String']['input']>;
  productName?: InputMaybe<Scalars['String']['input']>;
  productTier: ProductTier;
  signupSource: SignupSource;
  token: Scalars['String']['input'];
};

export type CreateUserAccountInput = {
  billingCycle?: InputMaybe<BillingCycle>;
  contactEmail: Scalars['String']['input'];
  passwordHash: Scalars['String']['input'];
  paymentToken?: InputMaybe<Scalars['String']['input']>;
  productTier: ProductTier;
  username: Scalars['String']['input'];
};

export type CustomerInfoInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type DesignBoard = {
  __typename?: 'DesignBoard';
  _id: Scalars['ID']['output'];
  color?: Maybe<Array<Maybe<ColorFamily>>>;
  description?: Maybe<Scalars['String']['output']>;
  designerId: Scalars['ID']['output'];
  featuredOnBio?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  finish?: Maybe<Array<Maybe<Finishes>>>;
  greatFor?: Maybe<GreatFor>;
  images?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Array<Maybe<Patterns>>>;
  roomType?: Maybe<Array<Maybe<ProjectCategory>>>;
  texture?: Maybe<Array<Maybe<Textures>>>;
  type?: Maybe<DesignBoardType>;
  why?: Maybe<Scalars['String']['output']>;
};

export enum DesignBoardType {
  Color = 'Color',
  Mood = 'Mood',
  PatternPlay = 'PatternPlay',
  StyleFusion = 'StyleFusion',
  TextureAndFinish = 'TextureAndFinish'
}

export enum DesignItems {
  AntiqueSelection = 'ANTIQUE_SELECTION',
  ArtSelection = 'ART_SELECTION',
  Basement = 'BASEMENT',
  ColorConsulting = 'COLOR_CONSULTING',
  DiningRoom = 'DINING_ROOM',
  Entrydesign = 'ENTRYDESIGN',
  EventDecor = 'EVENT_DECOR',
  FamilyRoom = 'FAMILY_ROOM',
  FullHome = 'FULL_HOME',
  FurnitureSelection = 'FURNITURE_SELECTION',
  GuestBedroom = 'GUEST_BEDROOM',
  HomeOffice = 'HOME_OFFICE',
  HomeStaging = 'HOME_STAGING',
  KidsBedroom = 'KIDS_BEDROOM',
  Kitchen = 'KITCHEN',
  Lighting = 'LIGHTING',
  LivingRoom = 'LIVING_ROOM',
  Mudroom = 'MUDROOM',
  OtherBathroom = 'OTHER_BATHROOM',
  OutdoorSpace = 'OUTDOOR_SPACE',
  PrimaryBathroom = 'PRIMARY_BATHROOM',
  PrimaryBedroom = 'PRIMARY_BEDROOM',
  SpacePlanning = 'SPACE_PLANNING'
}

export enum DesignItemsSpecialNeeds {
  AccessibilityFeaturesForDisabilities = 'ACCESSIBILITY_FEATURES_FOR_DISABILITIES',
  ArtIntegration = 'ART_INTEGRATION',
  CustomStorageSolutions = 'CUSTOM_STORAGE_SOLUTIONS',
  EnvironmentallySustainableMaterials = 'ENVIRONMENTALLY_SUSTAINABLE_MATERIALS',
  FengShui = 'FENG_SHUI',
  HistoricalPresercationConsideration = 'HISTORICAL_PRESERCATION_CONSIDERATION',
  HomeGym = 'HOME_GYM',
  OutdoorLivingConnections = 'OUTDOOR_LIVING_CONNECTIONS',
  PetFriendlyElements = 'PET_FRIENDLY_ELEMENTS',
  SmartHomeIntegration = 'SMART_HOME_INTEGRATION',
  SpecializedVentilationSystems = 'SPECIALIZED_VENTILATION_SYSTEMS',
  SpecificAcousticTreatments = 'SPECIFIC_ACOUSTIC_TREATMENTS',
  UniqueLightingEffects = 'UNIQUE_LIGHTING_EFFECTS',
  WineCellar = 'WINE_CELLAR'
}

export type DesignerApplication = {
  __typename?: 'DesignerApplication';
  _id: Scalars['ID']['output'];
  businessGoals?: Maybe<BusinessGoals>;
  designerId?: Maybe<Scalars['ID']['output']>;
  education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  experience?: Maybe<Array<Maybe<WorkExperience>>>;
  membershipTier?: Maybe<DesignerSubscriptionType>;
  references?: Maybe<Array<Maybe<Reference>>>;
  singlePaymentItems?: Maybe<Array<Maybe<SinglePaymentItems>>>;
  status?: Maybe<DesignerApplicationSteps>;
};

export enum DesignerApplicationSteps {
  Approved = 'Approved',
  CompleteApplication = 'CompleteApplication',
  MembershipActive = 'MembershipActive',
  Rejected = 'Rejected',
  ToBeCompleted = 'ToBeCompleted',
  UnderReview = 'UnderReview'
}

export type DesignerBio = {
  __typename?: 'DesignerBio';
  _id?: Maybe<Scalars['ID']['output']>;
  aboutMe?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<Scalars['ID']['output']>;
  coverImagePositionX?: Maybe<Scalars['Float']['output']>;
  coverImagePositionY?: Maybe<Scalars['Float']['output']>;
  currentlyReading?: Maybe<Scalars['String']['output']>;
  designAdvice?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  favoriteBook?: Maybe<Scalars['String']['output']>;
  favoriteMovie?: Maybe<Scalars['String']['output']>;
  favoriteMusicGenre?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['ID']['output']>;
  reviews?: Maybe<Array<Maybe<DesignerReview>>>;
  userName?: Maybe<Scalars['String']['output']>;
  whyWorkWithMe?: Maybe<Scalars['String']['output']>;
  yearsExperience?: Maybe<Scalars['Int']['output']>;
};

export enum DesignerFileType {
  BeforeAndAfter = 'BeforeAndAfter',
  DesignBoard = 'DesignBoard',
  ProjectProfile = 'ProjectProfile'
}

export type DesignerMatchingProfile = {
  __typename?: 'DesignerMatchingProfile';
  _id: Scalars['ID']['output'];
  designerId: Scalars['ID']['output'];
  expertise?: Maybe<DesignerMatchingProfileExpertise>;
  personalityType?: Maybe<PersonalityType>;
  preferences?: Maybe<DesignerMatchingProfilePreferences>;
  stepCompletion?: Maybe<DesignerMatchingProfileStepCompletion>;
  style?: Maybe<DesignerMatchingProfileStyle>;
  workStyle?: Maybe<DesignerMatchingProfileWorkStyle>;
};

export type DesignerMatchingProfileExpertise = {
  __typename?: 'DesignerMatchingProfileExpertise';
  competency?: Maybe<ExpertiseCompetency>;
  experience?: Maybe<Array<Maybe<MatchingProfileExperience>>>;
  experienceRankings?: Maybe<Array<Maybe<ExperienceRanking>>>;
  otherExperience?: Maybe<Scalars['String']['output']>;
  projectRankings?: Maybe<Array<Maybe<ProjectCategoryRanking>>>;
  projectTypes?: Maybe<Array<Maybe<ProjectCategory>>>;
};

export type DesignerMatchingProfileExpertiseInput = {
  competency?: InputMaybe<ExpertiseCompetencyInput>;
  experience?: InputMaybe<Array<InputMaybe<MatchingProfileExperience>>>;
  experienceRankings?: InputMaybe<Array<InputMaybe<ExperienceRankingInput>>>;
  otherExperience?: InputMaybe<Scalars['String']['input']>;
  projectRankings?: InputMaybe<Array<InputMaybe<ProjectCategoryRankingInput>>>;
  projectTypes?: InputMaybe<Array<InputMaybe<ProjectCategory>>>;
};

export type DesignerMatchingProfilePreferences = {
  __typename?: 'DesignerMatchingProfilePreferences';
  acquisitionPreferences?: Maybe<Array<Maybe<AquisitionPreferences>>>;
  acquisitionRankings?: Maybe<Array<Maybe<AquisitionRanking>>>;
  ageRange?: Maybe<AgeRange>;
  children?: Maybe<Scalars['Boolean']['output']>;
  partnershipStyleRankings?: Maybe<Array<Maybe<ParternshipStyleRanking>>>;
  social?: Maybe<ProfileSocialPreferences>;
  zipCodes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DesignerMatchingProfilePreferencesInput = {
  acquisitionPreferences?: InputMaybe<Array<InputMaybe<AquisitionPreferences>>>;
  acquisitionRankings?: InputMaybe<Array<InputMaybe<AquisitionRankingInput>>>;
  ageRange?: InputMaybe<AgeRange>;
  children?: InputMaybe<Scalars['Boolean']['input']>;
  partnershipStyleRankings?: InputMaybe<Array<InputMaybe<ParternshipStyleRankingInput>>>;
  social?: InputMaybe<ProfileSocialPreferencesInput>;
  zipCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DesignerMatchingProfileStepCompletion = {
  __typename?: 'DesignerMatchingProfileStepCompletion';
  expertiseCompleted?: Maybe<Scalars['Boolean']['output']>;
  personalityCompleted?: Maybe<Scalars['Boolean']['output']>;
  preferencesCompleted?: Maybe<Scalars['Boolean']['output']>;
  styleCompleted?: Maybe<Scalars['Boolean']['output']>;
  workStyleCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type DesignerMatchingProfileStepCompletionInput = {
  expertiseCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  personalityCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  preferencesCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  styleCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  workStyleCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DesignerMatchingProfileStyle = {
  __typename?: 'DesignerMatchingProfileStyle';
  anyStyle?: Maybe<Scalars['Boolean']['output']>;
  knownForStyle?: Maybe<ProjectStyles>;
  strongStyles?: Maybe<Array<Maybe<ProjectStyles>>>;
  styleRankings?: Maybe<Array<Maybe<StyleRanking>>>;
};

export type DesignerMatchingProfileStyleInput = {
  anyStyle?: InputMaybe<Scalars['Boolean']['input']>;
  knownForStyle?: InputMaybe<ProjectStyles>;
  strongStyles?: InputMaybe<Array<InputMaybe<ProjectStyles>>>;
  styleRankings?: InputMaybe<Array<InputMaybe<StyleRankingInput>>>;
};

export type DesignerMatchingProfileWorkStyle = {
  __typename?: 'DesignerMatchingProfileWorkStyle';
  compensationModel?: Maybe<Array<Maybe<CompensationModel>>>;
  minimumBudget?: Maybe<BudgetRange>;
  partnershipOptions?: Maybe<Array<Maybe<PartnershipOptions>>>;
  presentationType?: Maybe<Array<Maybe<PresentationType>>>;
};

export type DesignerMatchingProfileWorkStyleInput = {
  compensationModel?: InputMaybe<Array<InputMaybe<CompensationModel>>>;
  minimumBudget?: InputMaybe<BudgetRange>;
  partnershipOptions?: InputMaybe<Array<InputMaybe<PartnershipOptions>>>;
  presentationType?: InputMaybe<Array<InputMaybe<PresentationType>>>;
};

export type DesignerOnboardingStatus = {
  __typename?: 'DesignerOnboardingStatus';
  bioComplete?: Maybe<Scalars['Boolean']['output']>;
  designFilesComplete?: Maybe<Scalars['Boolean']['output']>;
  matchingProfileComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type DesignerQualification = {
  __typename?: 'DesignerQualification';
  label: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
};

export type DesignerReview = {
  __typename?: 'DesignerReview';
  author: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Float']['output'];
  source?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type DesignerReviewInput = {
  author: Scalars['String']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Float']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type DesignerStepStatus = {
  __typename?: 'DesignerStepStatus';
  completedSteps: Array<Scalars['Int']['output']>;
  currentStep: Scalars['Int']['output'];
  nextStep?: Maybe<Scalars['Int']['output']>;
  profile?: Maybe<DesignerMatchingProfile>;
  profileExists: Scalars['Boolean']['output'];
};

export enum DesignerSubscriptionType {
  Design = 'Design',
  DesignBeta = 'DesignBETA',
  DesignBiAnnually = 'DesignBiAnnually',
  DesignBiAnnuallyBeta = 'DesignBiAnnuallyBETA',
  DesignMonthly = 'DesignMonthly',
  DesignMonthlyBeta = 'DesignMonthlyBETA',
  DesignPlus = 'DesignPlus',
  DesignPlusBeta = 'DesignPlusBETA',
  DesignPlusBiAnnually = 'DesignPlusBiAnnually',
  DesignPlusBiAnnuallyBeta = 'DesignPlusBiAnnuallyBETA',
  DesignPlusMonthly = 'DesignPlusMonthly',
  DesignPlusMonthlyBeta = 'DesignPlusMonthlyBETA',
  Guild = 'Guild',
  GuildBeta = 'GuildBETA',
  GuildBiAnnually = 'GuildBiAnnually',
  GuildBiAnnuallyBeta = 'GuildBiAnnuallyBETA',
  GuildPlus = 'GuildPlus',
  GuildPlusBeta = 'GuildPlusBETA',
  Home = 'Home',
  HomeBeta = 'HomeBETA',
  HomeBiAnnually = 'HomeBiAnnually',
  HomeBiAnnuallyBeta = 'HomeBiAnnuallyBETA',
  HomeMonthly = 'HomeMonthly',
  HomeMonthlyBeta = 'HomeMonthlyBETA'
}

export type DesignerSubscriptionWrapper = {
  __typename?: 'DesignerSubscriptionWrapper';
  value?: Maybe<DesignerSubscriptionType>;
};

export type DesignerUser = {
  __typename?: 'DesignerUser';
  _id: Scalars['ID']['output'];
  aboutMe?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<UserAccountType>;
  aliasId?: Maybe<Scalars['String']['output']>;
  businessAddress?: Maybe<Scalars['String']['output']>;
  businessCity?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessState?: Maybe<States>;
  businessWebsite?: Maybe<Scalars['String']['output']>;
  businessZipCode?: Maybe<Scalars['String']['output']>;
  communicationPreference?: Maybe<Array<Maybe<CommunicationPreference>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  designerApplication?: Maybe<Scalars['ID']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numYears?: Maybe<Scalars['Int']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Array<Maybe<DesignerQualification>>>;
  revenueSharingEligible?: Maybe<Scalars['Boolean']['output']>;
  subscription?: Maybe<DesignerSubscriptionType>;
  title?: Maybe<Scalars['String']['output']>;
  wixMemberId?: Maybe<Scalars['String']['output']>;
  workLocation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum EmploymentType {
  ForSomeone = 'ForSomeone',
  SelfEmployed = 'SelfEmployed'
}

export type ExperienceRanking = {
  __typename?: 'ExperienceRanking';
  experience?: Maybe<MatchingProfileExperience>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type ExperienceRankingInput = {
  experience?: InputMaybe<MatchingProfileExperience>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
};

export type ExpertiseCompetency = {
  __typename?: 'ExpertiseCompetency';
  accessibility?: Maybe<CompetencyLevel>;
  artIntegration?: Maybe<CompetencyLevel>;
  customStorage?: Maybe<CompetencyLevel>;
  evironmentallySustainable?: Maybe<CompetencyLevel>;
  fengShui?: Maybe<CompetencyLevel>;
  historicalPreservation?: Maybe<CompetencyLevel>;
  homeGym?: Maybe<CompetencyLevel>;
  outdoorLiving?: Maybe<CompetencyLevel>;
  petFriendly?: Maybe<CompetencyLevel>;
  smartHome?: Maybe<CompetencyLevel>;
  specializedVentilation?: Maybe<CompetencyLevel>;
  specificAcoustic?: Maybe<CompetencyLevel>;
  strengths?: Maybe<Array<Maybe<StrengthRanking>>>;
  uniqueLightingEffects?: Maybe<CompetencyLevel>;
  wineCellar?: Maybe<CompetencyLevel>;
};

export type ExpertiseCompetencyInput = {
  accessibility?: InputMaybe<CompetencyLevel>;
  artIntegration?: InputMaybe<CompetencyLevel>;
  customStorage?: InputMaybe<CompetencyLevel>;
  evironmentallySustainable?: InputMaybe<CompetencyLevel>;
  fengShui?: InputMaybe<CompetencyLevel>;
  historicalPreservation?: InputMaybe<CompetencyLevel>;
  homeGym?: InputMaybe<CompetencyLevel>;
  outdoorLiving?: InputMaybe<CompetencyLevel>;
  petFriendly?: InputMaybe<CompetencyLevel>;
  smartHome?: InputMaybe<CompetencyLevel>;
  specializedVentilation?: InputMaybe<CompetencyLevel>;
  specificAcoustic?: InputMaybe<CompetencyLevel>;
  strengths?: InputMaybe<Array<InputMaybe<StrengthRankingInput>>>;
  uniqueLightingEffects?: InputMaybe<CompetencyLevel>;
  wineCellar?: InputMaybe<CompetencyLevel>;
};

export type FeatureSet = {
  __typename?: 'FeatureSet';
  description: Scalars['String']['output'];
  education: Scalars['Boolean']['output'];
  guildGuideArticles: GuideArticlesAccess;
  ideaBooks: Scalars['Boolean']['output'];
  powerfulFilters: Scalars['Boolean']['output'];
  projectGallery: ProjectGalleryAccess;
  smartGuildMatching: Scalars['Boolean']['output'];
};

export type FeatureSetInput = {
  description: Scalars['String']['input'];
  education: Scalars['Boolean']['input'];
  guildGuideArticles: GuideArticlesAccess;
  ideaBooks: Scalars['Boolean']['input'];
  powerfulFilters: Scalars['Boolean']['input'];
  projectGallery: ProjectGalleryAccess;
  smartGuildMatching: Scalars['Boolean']['input'];
};

export enum Finishes {
  Carpet = 'Carpet',
  DecorativeStone = 'DecorativeStone',
  Hardwood = 'Hardwood',
  Marble = 'Marble',
  Metallic = 'Metallic',
  Paint = 'Paint',
  Tile = 'Tile',
  Vinyl = 'Vinyl',
  Wallpaper = 'Wallpaper',
  Wood = 'Wood'
}

export enum FirmSize {
  Indepenedent = 'Indepenedent',
  SixAndUp = 'SixAndUp',
  ThreeToFive = 'ThreeToFive',
  Two = 'Two'
}

export enum GreatFor {
  AllSpaces = 'AllSpaces',
  BrightSpaces = 'BrightSpaces',
  DarkSpaces = 'DarkSpaces',
  LargeSpaces = 'LargeSpaces',
  RoomsWithHighCeilings = 'RoomsWithHighCeilings',
  RoomsWithLowCeilings = 'RoomsWithLowCeilings',
  SmallSpaces = 'SmallSpaces'
}

export enum GuideArticlesAccess {
  FullAccess = 'full_access',
  Limited = 'limited'
}

export type HoAquisitionRanking = {
  __typename?: 'HOAquisitionRanking';
  acquisitionPreference?: Maybe<AquisitionPreferences>;
};

export type HoAquisitionRankingInput = {
  acquisitionPreference?: InputMaybe<AquisitionPreferences>;
};

export type HoParternshipStyle = {
  __typename?: 'HOParternshipStyle';
  partnershipStyle?: Maybe<PartnershipStyle>;
};

export type HoParternshipStyleInput = {
  partnershipStyle?: InputMaybe<PartnershipStyle>;
};

export type HomeOwnerMatchingProfile = {
  __typename?: 'HomeOwnerMatchingProfile';
  _id: Scalars['ID']['output'];
  homeOwnerId: Scalars['ID']['output'];
  homeOwnerStyles?: Maybe<HomeOwnerInterestedStyles>;
  personalityType?: Maybe<PersonalityType>;
  preferences?: Maybe<HomeOwnerMatchingProfilePreference>;
  priorities?: Maybe<HomeOwnerPriorities>;
  projectType?: Maybe<HomeOwnerMatchingProfileProject>;
  stepCompletion?: Maybe<HomeOwnerMatchingProfileStepCompletion>;
};

export type HomeOwnerMatchingProfilePreference = {
  __typename?: 'HomeOwnerMatchingProfilePreference';
  acquisitionPreference?: Maybe<Scalars['String']['output']>;
  billingMethods?: Maybe<Array<Scalars['String']['output']>>;
  budgetRange?: Maybe<Scalars['String']['output']>;
  designerGenderPreference?: Maybe<Scalars['String']['output']>;
  designerPetPreference?: Maybe<Array<Scalars['String']['output']>>;
  designerRole?: Maybe<Scalars['String']['output']>;
  desiredAgeRange?: Maybe<Scalars['String']['output']>;
  experiencePreference?: Maybe<Scalars['String']['output']>;
  hireLikelihood?: Maybe<Scalars['String']['output']>;
  hasChildrenPreference?: Maybe<Scalars['String']['output']>;
  lgbtqFriendly?: Maybe<Scalars['String']['output']>;
  minorityOwnedPreference?: Maybe<Scalars['String']['output']>;
  partnershipStyle?: Maybe<Scalars['String']['output']>;
  politicalAffiliation?: Maybe<Scalars['String']['output']>;
  sameAgeRangePreference?: Maybe<Scalars['String']['output']>;
  samePolitics?: Maybe<Scalars['String']['output']>;
  skillRankings?: Maybe<Array<Scalars['String']['output']>>;
  wantsFinancing?: Maybe<Scalars['String']['output']>;
  womenOwnedFirm?: Maybe<Scalars['String']['output']>;
};

export type HomeOwnerMatchingProfilePreferenceInput = {
  acquisitionPreference?: InputMaybe<Scalars['String']['input']>;
  billingMethods?: InputMaybe<Array<Scalars['String']['input']>>;
  budgetRange?: InputMaybe<Scalars['String']['input']>;
  designerGenderPreference?: InputMaybe<Scalars['String']['input']>;
  designerPetPreference?: InputMaybe<Array<Scalars['String']['input']>>;
  designerRole?: InputMaybe<Scalars['String']['input']>;
  desiredAgeRange?: InputMaybe<Scalars['String']['input']>;
  experiencePreference?: InputMaybe<Scalars['String']['input']>;
  hireLikelihood?: InputMaybe<Scalars['String']['input']>;
  hasChildrenPreference?: InputMaybe<Scalars['String']['input']>;
  lgbtqFriendly?: InputMaybe<Scalars['String']['input']>;
  minorityOwnedPreference?: InputMaybe<Scalars['String']['input']>;
  partnershipStyle?: InputMaybe<Scalars['String']['input']>;
  politicalAffiliation?: InputMaybe<Scalars['String']['input']>;
  sameAgeRangePreference?: InputMaybe<Scalars['String']['input']>;
  samePolitics?: InputMaybe<Scalars['String']['input']>;
  skillRankings?: InputMaybe<Array<Scalars['String']['input']>>;
  wantsFinancing?: InputMaybe<Scalars['String']['input']>;
  womenOwnedFirm?: InputMaybe<Scalars['String']['input']>;
};

export type HomeOwnerMatchingProfileProject = {
  __typename?: 'HomeOwnerMatchingProfileProject';
  conceptPresentation?: Maybe<PresentationType>;
  designItems?: Maybe<Array<Maybe<DesignItems>>>;
  projectAddress?: Maybe<Address>;
  projectType?: Maybe<MatchingProfileExperience>;
  specialNeeds?: Maybe<Array<Maybe<DesignItemsSpecialNeeds>>>;
};

export type HomeOwnerMatchingProfileProjectInput = {
  conceptPresentation?: InputMaybe<PresentationType>;
  designItems?: InputMaybe<Array<InputMaybe<DesignItems>>>;
  projectAddress?: InputMaybe<AddressInput>;
  projectType?: InputMaybe<MatchingProfileExperience>;
  specialNeeds?: InputMaybe<Array<InputMaybe<DesignItemsSpecialNeeds>>>;
};

export type HomeOwnerMatchingProfileStepCompletion = {
  __typename?: 'HomeOwnerMatchingProfileStepCompletion';
  personalityCompleted?: Maybe<Scalars['Boolean']['output']>;
  preferenceCompleted?: Maybe<Scalars['Boolean']['output']>;
  prioritiesCompleted?: Maybe<Scalars['Boolean']['output']>;
  projectCompleted?: Maybe<Scalars['Boolean']['output']>;
  styleCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type HomeOwnerMatchingProfileStepCompletionInput = {
  personalityCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  preferenceCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  prioritiesCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  projectCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  styleCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeOwnerPoliticalPref = {
  __typename?: 'HomeOwnerPoliticalPref';
  PoliticalAffiliation?: Maybe<PoliticalAffiliation>;
  isPoliticalAffiliated?: Maybe<Scalars['Boolean']['output']>;
};

export type HomeOwnerPoliticalPrefInput = {
  PoliticalAffiliation?: InputMaybe<PoliticalAffiliation>;
  isPoliticalAffiliated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeOwnerPriorities = {
  __typename?: 'HomeOwnerPriorities';
  order: Array<HomeOwnerPriorityCategory>;
};

export type HomeOwnerPrioritiesInput = {
  order: Array<HomeOwnerPriorityCategory>;
};

export enum HomeOwnerPriorityCategory {
  Budget = 'BUDGET',
  CompatiblePersonalities = 'COMPATIBLE_PERSONALITIES',
  CompatiblePersonalPreferences = 'COMPATIBLE_PERSONAL_PREFERENCES',
  DesignerYearsExperience = 'DESIGNER_YEARS_EXPERIENCE',
  HowDesignerBills = 'HOW_DESIGNER_BILLS',
  IdealDesignerTraits = 'IDEAL_DESIGNER_TRAITS',
  ProjectFinancing = 'PROJECT_FINANCING',
  ProjectSpecialNeeds = 'PROJECT_SPECIAL_NEEDS',
  Style = 'STYLE',
  Timeline = 'TIMELINE'
}

export type HomeOwnerProfileSocialPref = {
  __typename?: 'HomeOwnerProfileSocialPref';
  Pronouns?: Maybe<Scalars['Boolean']['output']>;
  minorityOwned?: Maybe<Scalars['Boolean']['output']>;
  otherPoliticalAffiliation?: Maybe<Scalars['String']['output']>;
  pets?: Maybe<Array<Maybe<Pets>>>;
  politicalAffiliation?: Maybe<PoliticalAffiliation>;
  preferSamePolitics?: Maybe<Scalars['Boolean']['output']>;
  pronouns?: Maybe<Pronouns>;
  womenOwned?: Maybe<Scalars['Boolean']['output']>;
};

export type HomeOwnerProfileSocialPrefInput = {
  lgbtqPositive?: InputMaybe<Scalars['Boolean']['input']>;
  minorityOwned?: InputMaybe<Scalars['Boolean']['input']>;
  otherPoliticalAffiliation?: InputMaybe<Scalars['String']['input']>;
  pets?: InputMaybe<Array<InputMaybe<Pets>>>;
  politicalAffiliation?: InputMaybe<PoliticalAffiliation>;
  preferSamePolitics?: InputMaybe<Scalars['Boolean']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  womenOwned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeOwnerSocialPreferences = {
  __typename?: 'HomeOwnerSocialPreferences';
  designerAgeRange?: Maybe<AgeRange>;
  designerWorkExperience?: Maybe<YearsOfExperience>;
  interestedDesignerPets?: Maybe<Array<Maybe<Pets>>>;
  interestedDesignerWithKids?: Maybe<Scalars['Boolean']['output']>;
  lgbtqPositive?: Maybe<Scalars['Boolean']['output']>;
  minorityOwned?: Maybe<Scalars['Boolean']['output']>;
  politicalAffiliation?: Maybe<HomeOwnerPoliticalPref>;
  pronouns?: Maybe<Pronouns>;
  womenOwned?: Maybe<Scalars['Boolean']['output']>;
};

export type HomeOwnerSocialPreferencesInput = {
  designerAgeRange?: InputMaybe<AgeRange>;
  designerWorkExperience?: InputMaybe<YearsOfExperience>;
  interestedDesignerPets?: InputMaybe<Array<InputMaybe<Pets>>>;
  interestedDesignerWithKids?: InputMaybe<Scalars['Boolean']['input']>;
  lgbtqPositive?: InputMaybe<Scalars['Boolean']['input']>;
  minorityOwned?: InputMaybe<Scalars['Boolean']['input']>;
  politicalAffiliation?: InputMaybe<HomeOwnerPoliticalPrefInput>;
  pronouns?: InputMaybe<Pronouns>;
  womenOwned?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomeOwnerSubscriptionTypes {
  Free = 'Free',
  GuildAnnually = 'GuildAnnually',
  GuildMonthly = 'GuildMonthly',
  StyleFileAnnually = 'StyleFileAnnually',
  StyleFileMonthly = 'StyleFileMonthly'
}

export type HomeOwnerSubscriptionWrapper = {
  __typename?: 'HomeOwnerSubscriptionWrapper';
  value?: Maybe<HomeOwnerSubscriptionTypes>;
};

export type HomeOwnerUser = {
  __typename?: 'HomeOwnerUser';
  _id: Scalars['ID']['output'];
  accountStatus?: Maybe<HomeownerAccountStatus>;
  accountType?: Maybe<UserAccountType>;
  address?: Maybe<Scalars['String']['output']>;
  aliasId?: Maybe<Scalars['String']['output']>;
  authorizationCode?: Maybe<Scalars['String']['output']>;
  billingInfo?: Maybe<BillingInfo>;
  city?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  emailVerified?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  image?: Maybe<Scalars['ID']['output']>;
  lastName: Scalars['String']['output'];
  matches?: Maybe<Array<Maybe<MatchInstance>>>;
  password: Scalars['String']['output'];
  paymentDate?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<HomeOwnerSubscriptionTypes>;
  subscriptionDate?: Maybe<Scalars['String']['output']>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
  transactionId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wixMemberId: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export enum HomeownerAccountStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Pending = 'Pending'
}

export type HomeownerStepStatus = {
  __typename?: 'HomeownerStepStatus';
  completedSteps: Array<Scalars['String']['output']>;
  currentStep: Scalars['Int']['output'];
  nextStep: Scalars['String']['output'];
  profile?: Maybe<HomeOwnerMatchingProfile>;
  profileExists: Scalars['Boolean']['output'];
};

export type MatchInstance = {
  __typename?: 'MatchInstance';
  id: Scalars['ID']['output'];
  matchScore?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum MatchingProfileExperience {
  Other = 'Other',
  PrimaryResidence = 'PrimaryResidence',
  RentalProperty = 'RentalProperty',
  SmallCommercial = 'SmallCommercial',
  VacationHomeBeachHouse = 'VacationHomeBeachHouse',
  VacationHomeLakeHouse = 'VacationHomeLakeHouse',
  VacationHomeLodge = 'VacationHomeLodge'
}

export enum MatchingProfileStrengths {
  Accessibility = 'accessibility',
  Adaptability = 'adaptability',
  AttentionToDetail = 'attentionToDetail',
  BudgetManagement = 'budgetManagement',
  Collaboration = 'collaboration',
  Communication = 'communication',
  Creativity = 'creativity',
  ProblemSolving = 'problemSolving',
  ProjectManagement = 'projectManagement',
  TimelineManagement = 'timelineManagement'
}

export type MediaFile = {
  __typename?: 'MediaFile';
  _id?: Maybe<Scalars['ID']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  approveDesignerApplication?: Maybe<Scalars['Boolean']['output']>;
  completeCourse: CourseCompletionResponse;
  completePasswordReset?: Maybe<Scalars['Boolean']['output']>;
  confirmEmail?: Maybe<Scalars['String']['output']>;
  confirmPaymentToken: PaymentConfirmationResponse;
  createAdminUser?: Maybe<AdminUser>;
  createBeforeAndAfterProject?: Maybe<BeforeAndAfterProject>;
  createDesignerApplication?: Maybe<Scalars['ID']['output']>;
  createDesignerBio?: Maybe<DesignerBio>;
  createDesignerMatchingProfile?: Maybe<Scalars['Boolean']['output']>;
  createHomeOwnerMatchingProfile?: Maybe<Scalars['Boolean']['output']>;
  createNewAccount?: Maybe<UserFromServer>;
  createNewDesignBoard?: Maybe<DesignBoard>;
  createNewDesignerAccount?: Maybe<Scalars['String']['output']>;
  createNewHomeownerAccount?: Maybe<Scalars['String']['output']>;
  createNewProjectFile?: Maybe<ProjectFile>;
  createPayment: Payment;
  createUserAccount: UserAccount;
  deleteAdminUser?: Maybe<Scalars['Boolean']['output']>;
  deleteBeforeAndAfterProject?: Maybe<Scalars['Boolean']['output']>;
  deleteDesignBoard?: Maybe<Scalars['Boolean']['output']>;
  deleteDesignerAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteDesignerApplication?: Maybe<Scalars['Boolean']['output']>;
  deleteHomeownerAccount?: Maybe<Scalars['Boolean']['output']>;
  deleteMediaFile?: Maybe<Scalars['Boolean']['output']>;
  deleteProjectFile?: Maybe<Scalars['Boolean']['output']>;
  generateBeforeAndAfterShareToken?: Maybe<BeforeAndAfterProject>;
  generateUserAlias?: Maybe<AliasGenerationResult>;
  generateVerificationCode?: Maybe<Scalars['Boolean']['output']>;
  getAcceptHostedToken?: Maybe<Scalars['String']['output']>;
  getAllAdminUsers: Array<AdminUser>;
  getAuthorizeNetToken: Scalars['String']['output'];
  loginUser?: Maybe<UserFromServer>;
  processPayment?: Maybe<PaymentResult>;
  rejectDesignerApplication?: Maybe<Scalars['Boolean']['output']>;
  requestPasswordReset?: Maybe<Scalars['Boolean']['output']>;
  resendConfirmationEmail?: Maybe<Scalars['Boolean']['output']>;
  resendVerificationCode?: Maybe<Scalars['Boolean']['output']>;
  resetAdminPassword?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use requestPasswordReset, verifyPasswordResetCode, and completePasswordReset instead */
  resetPassword?: Maybe<Scalars['Boolean']['output']>;
  startCourseEnrollment: CourseEnrollmentResponse;
  updateAdminUser?: Maybe<AdminUser>;
  updateBeforeAndAfterProject?: Maybe<BeforeAndAfterProject>;
  updateDesignBoard?: Maybe<DesignBoard>;
  updateDesignerAccount?: Maybe<UserFromServer>;
  updateDesignerApplication?: Maybe<Scalars['ID']['output']>;
  updateDesignerBio?: Maybe<DesignerBio>;
  updateDesignerMatchingProfile?: Maybe<Scalars['Boolean']['output']>;
  updateHomeOwnerMatchingProfile?: Maybe<Scalars['Boolean']['output']>;
  updateHomeownerAccount?: Maybe<UserFromServer>;
  updateMediaFile?: Maybe<MediaFile>;
  updateOnboardingStatus?: Maybe<Scalars['Boolean']['output']>;
  updatePaymentSettings: PaymentSettings;
  updatePaymentStatus: Payment;
  updateProjectFile?: Maybe<ProjectFile>;
  updateUserAccountTier: UserAccount;
  uploadMediaFile?: Maybe<MediaFile>;
  usePaymentToken: UserAccount;
  verifyCode?: Maybe<Scalars['Boolean']['output']>;
  verifyPasswordResetCode?: Maybe<Scalars['Boolean']['output']>;
};


export type MutationApproveDesignerApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationCompleteCourseArgs = {
  completionData?: InputMaybe<CompletionDataInput>;
  courseId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCompletePasswordResetArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationConfirmEmailArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationConfirmPaymentTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationCreateAdminUserArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  permissions: Array<AdminPermission>;
  role: AdminRole;
};


export type MutationCreateBeforeAndAfterProjectArgs = {
  additionalSections?: InputMaybe<Array<InputMaybe<AdditionalSectionInput>>>;
  afterImage?: InputMaybe<Scalars['ID']['input']>;
  afterImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  beforeImage?: InputMaybe<Scalars['ID']['input']>;
  beforeImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  budgetRange?: InputMaybe<BudgetRange>;
  challenges?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerId?: InputMaybe<Scalars['ID']['input']>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<Scalars['String']['input']>;
  projectCategory?: InputMaybe<ProjectCategory>;
  projectDuration?: InputMaybe<ProjectDuration>;
  projectStyle?: InputMaybe<ProjectStyles>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>>>;
  squareFootage?: InputMaybe<SquareFootage>;
  storySubtitle?: InputMaybe<Scalars['String']['input']>;
  storyTitle?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
  wishList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationCreateDesignerApplicationArgs = {
  designerId: Scalars['ID']['input'];
  experience?: InputMaybe<Array<InputMaybe<ApplicationExperience>>>;
};


export type MutationCreateDesignerBioArgs = {
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  coverImagePositionX?: InputMaybe<Scalars['Float']['input']>;
  coverImagePositionY?: InputMaybe<Scalars['Float']['input']>;
  currentlyReading?: InputMaybe<Scalars['String']['input']>;
  designAdvice?: InputMaybe<Scalars['String']['input']>;
  designerId: Scalars['String']['input'];
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favoriteBook?: InputMaybe<Scalars['String']['input']>;
  favoriteMovie?: InputMaybe<Scalars['String']['input']>;
  favoriteMusicGenre?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  reviews?: InputMaybe<Array<DesignerReviewInput>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  whyWorkWithMe?: InputMaybe<Scalars['String']['input']>;
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateDesignerMatchingProfileArgs = {
  designerId: Scalars['String']['input'];
  expertise?: InputMaybe<DesignerMatchingProfileExpertiseInput>;
  personalityType?: InputMaybe<PersonalityType>;
  preferences?: InputMaybe<DesignerMatchingProfilePreferencesInput>;
  stepCompletion?: InputMaybe<DesignerMatchingProfileStepCompletionInput>;
  style?: InputMaybe<DesignerMatchingProfileStyleInput>;
  workStyle?: InputMaybe<DesignerMatchingProfileWorkStyleInput>;
};


export type MutationCreateHomeOwnerMatchingProfileArgs = {
  homeOwnerId: Scalars['String']['input'];
  homeOwnerStyles?: InputMaybe<HomeOwnerInterestedStylesInput>;
  personalityType?: InputMaybe<PersonalityType>;
  preferences?: InputMaybe<HomeOwnerMatchingProfilePreferenceInput>;
  priorities?: InputMaybe<HomeOwnerPrioritiesInput>;
  projectType?: InputMaybe<HomeOwnerMatchingProfileProjectInput>;
  stepCompletion?: InputMaybe<HomeOwnerMatchingProfileStepCompletionInput>;
};


export type MutationCreateNewAccountArgs = {
  accountType: UserAccountType;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationCreateNewDesignBoardArgs = {
  color?: InputMaybe<Array<InputMaybe<ColorFamily>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerId?: InputMaybe<Scalars['ID']['input']>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  finish?: InputMaybe<Array<InputMaybe<Finishes>>>;
  greatFor?: InputMaybe<GreatFor>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Array<InputMaybe<Patterns>>>;
  roomType?: InputMaybe<Array<InputMaybe<ProjectCategory>>>;
  texture?: InputMaybe<Array<InputMaybe<Textures>>>;
  type?: InputMaybe<DesignBoardType>;
  why?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateNewDesignerAccountArgs = {
  accountType: UserAccountType;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessCity?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessState?: InputMaybe<States>;
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  businessZipCode?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateNewHomeownerAccountArgs = {
  accountType: UserAccountType;
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateNewProjectFileArgs = {
  budgetRange?: InputMaybe<BudgetRange>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerId?: InputMaybe<Scalars['ID']['input']>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCategory?: InputMaybe<ProjectCategory>;
  projectDuration?: InputMaybe<ProjectDuration>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>>>;
  squareFootage?: InputMaybe<SquareFootage>;
  style?: InputMaybe<ProjectStyles>;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateUserAccountArgs = {
  input: CreateUserAccountInput;
};


export type MutationDeleteAdminUserArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteBeforeAndAfterProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationDeleteDesignBoardArgs = {
  designBoardId: Scalars['ID']['input'];
};


export type MutationDeleteDesignerAccountArgs = {
  designerId: Scalars['ID']['input'];
};


export type MutationDeleteDesignerApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationDeleteHomeownerAccountArgs = {
  homeownerId: Scalars['ID']['input'];
};


export type MutationDeleteMediaFileArgs = {
  _id: Scalars['ID']['input'];
};


export type MutationDeleteProjectFileArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationGenerateBeforeAndAfterShareTokenArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationGenerateUserAliasArgs = {
  userId: Scalars['ID']['input'];
  userType: Scalars['String']['input'];
};


export type MutationGenerateVerificationCodeArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationGetAcceptHostedTokenArgs = {
  amount: Scalars['Float']['input'];
  customerInfo: CustomerInfoInput;
  email: Scalars['String']['input'];
  planName: Scalars['String']['input'];
};


export type MutationGetAuthorizeNetTokenArgs = {
  amount: Scalars['Float']['input'];
  email: Scalars['String']['input'];
  planName: Scalars['String']['input'];
};


export type MutationLoginUserArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationProcessPaymentArgs = {
  amount: Scalars['Float']['input'];
  billingInfo: BillingInfoInput;
  email: Scalars['String']['input'];
  homeownerId: Scalars['ID']['input'];
  opaqueDataDescriptor: Scalars['String']['input'];
  opaqueDataValue: Scalars['String']['input'];
  planName: Scalars['String']['input'];
};


export type MutationRejectDesignerApplicationArgs = {
  applicationId: Scalars['ID']['input'];
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationResendConfirmationEmailArgs = {
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};


export type MutationResendVerificationCodeArgs = {
  email: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationResetAdminPasswordArgs = {
  _id: Scalars['ID']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationStartCourseEnrollmentArgs = {
  courseId: Scalars['String']['input'];
  crmWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationUpdateAdminUserArgs = {
  _id: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<AdminPermission>>;
  role?: InputMaybe<AdminRole>;
};


export type MutationUpdateBeforeAndAfterProjectArgs = {
  _id: Scalars['ID']['input'];
  additionalSections?: InputMaybe<Array<InputMaybe<AdditionalSectionInput>>>;
  afterImage?: InputMaybe<Scalars['ID']['input']>;
  afterImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  beforeImage?: InputMaybe<Scalars['ID']['input']>;
  beforeImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  budgetRange?: InputMaybe<BudgetRange>;
  challenges?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerId?: InputMaybe<Scalars['ID']['input']>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<Scalars['String']['input']>;
  projectCategory?: InputMaybe<ProjectCategory>;
  projectDuration?: InputMaybe<ProjectDuration>;
  projectStyle?: InputMaybe<ProjectStyles>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>>>;
  squareFootage?: InputMaybe<SquareFootage>;
  storySubtitle?: InputMaybe<Scalars['String']['input']>;
  storyTitle?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
  wishList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateDesignBoardArgs = {
  _id: Scalars['ID']['input'];
  color?: InputMaybe<Array<InputMaybe<ColorFamily>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerId: Scalars['ID']['input'];
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  finish?: InputMaybe<Array<InputMaybe<Finishes>>>;
  greatFor?: InputMaybe<GreatFor>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<Array<InputMaybe<Patterns>>>;
  roomType?: InputMaybe<Array<InputMaybe<ProjectCategory>>>;
  texture?: InputMaybe<Array<InputMaybe<Textures>>>;
  type?: InputMaybe<DesignBoardType>;
  why?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateDesignerAccountArgs = {
  _id: Scalars['ID']['input'];
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessCity?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessState?: InputMaybe<States>;
  businessWebsite?: InputMaybe<Scalars['String']['input']>;
  businessZipCode?: InputMaybe<Scalars['String']['input']>;
  communicationPreference?: InputMaybe<Array<InputMaybe<CommunicationPreference>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  workLocation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateDesignerApplicationArgs = {
  application: UpdateDesignerApplicationInput;
};


export type MutationUpdateDesignerBioArgs = {
  _id: Scalars['ID']['input'];
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  coverImagePositionX?: InputMaybe<Scalars['Float']['input']>;
  coverImagePositionY?: InputMaybe<Scalars['Float']['input']>;
  currentlyReading?: InputMaybe<Scalars['String']['input']>;
  designAdvice?: InputMaybe<Scalars['String']['input']>;
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  favoriteBook?: InputMaybe<Scalars['String']['input']>;
  favoriteMovie?: InputMaybe<Scalars['String']['input']>;
  favoriteMusicGenre?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  reviews?: InputMaybe<Array<DesignerReviewInput>>;
  userName?: InputMaybe<Scalars['String']['input']>;
  whyWorkWithMe?: InputMaybe<Scalars['String']['input']>;
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateDesignerMatchingProfileArgs = {
  _id: Scalars['ID']['input'];
  expertise?: InputMaybe<DesignerMatchingProfileExpertiseInput>;
  personalityType?: InputMaybe<PersonalityType>;
  preferences?: InputMaybe<DesignerMatchingProfilePreferencesInput>;
  stepCompletion?: InputMaybe<DesignerMatchingProfileStepCompletionInput>;
  style?: InputMaybe<DesignerMatchingProfileStyleInput>;
  workStyle?: InputMaybe<DesignerMatchingProfileWorkStyleInput>;
};


export type MutationUpdateHomeOwnerMatchingProfileArgs = {
  _id: Scalars['ID']['input'];
  homeOwnerStyles?: InputMaybe<HomeOwnerInterestedStylesInput>;
  personalityType?: InputMaybe<PersonalityType>;
  preferences?: InputMaybe<HomeOwnerMatchingProfilePreferenceInput>;
  priorities?: InputMaybe<HomeOwnerPrioritiesInput>;
  projectType?: InputMaybe<HomeOwnerMatchingProfileProjectInput>;
  stepCompletion?: InputMaybe<HomeOwnerMatchingProfileStepCompletionInput>;
};


export type MutationUpdateHomeownerAccountArgs = {
  _id: Scalars['ID']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  subscription?: InputMaybe<Scalars['String']['input']>;
  dmaCode?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMediaFileArgs = {
  _id: Scalars['ID']['input'];
  credit?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateOnboardingStatusArgs = {
  status: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUpdatePaymentSettingsArgs = {
  input: UpdatePaymentSettingsInput;
};


export type MutationUpdatePaymentStatusArgs = {
  input: UpdatePaymentStatusInput;
};


export type MutationUpdateProjectFileArgs = {
  _id: Scalars['ID']['input'];
  budgetRange?: InputMaybe<BudgetRange>;
  description?: InputMaybe<Scalars['String']['input']>;
  designerId?: InputMaybe<Scalars['ID']['input']>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  projectCategory?: InputMaybe<ProjectCategory>;
  projectDuration?: InputMaybe<ProjectDuration>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>>>;
  squareFootage?: InputMaybe<SquareFootage>;
  style?: InputMaybe<ProjectStyles>;
};


export type MutationUpdateUserAccountTierArgs = {
  email: Scalars['String']['input'];
  newTier: ProductTier;
};


export type MutationUploadMediaFileArgs = {
  credit?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUsePaymentTokenArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationVerifyCodeArgs = {
  code: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationVerifyPasswordResetCodeArgs = {
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
};

export type ParternshipStyleRanking = {
  __typename?: 'ParternshipStyleRanking';
  partnershipStyle?: Maybe<PartnershipStyle>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type ParternshipStyleRankingInput = {
  partnershipStyle?: InputMaybe<PartnershipStyle>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
};

export enum PartnershipOptions {
  Consultant = 'consultant',
  EDesign = 'eDesign',
  FullService = 'fullService'
}

export enum PartnershipStyle {
  Collaborative = 'collaborative',
  HighlyInvolved = 'highlyInvolved',
  LowInvolvement = 'lowInvolvement'
}

export enum Patterns {
  Abstract = 'Abstract',
  AnimalPrint = 'AnimalPrint',
  Argyle = 'Argyle',
  Basketweave = 'Basketweave',
  Chevron = 'Chevron',
  Damask = 'Damask',
  Diamond = 'Diamond',
  FleurDeLis = 'FleurDeLis',
  Floral = 'Floral',
  Fret = 'Fret',
  Geometric = 'Geometric',
  Gingham = 'Gingham',
  Graph = 'Graph',
  GreekKey = 'GreekKey',
  Harlequin = 'Harlequin',
  Herringbone = 'Herringbone',
  Houndstooth = 'Houndstooth',
  Ikat = 'Ikat',
  Kilm = 'Kilm',
  Lattice = 'Lattice',
  Madras = 'Madras',
  Navajo = 'Navajo',
  Ogee = 'Ogee',
  Ombre = 'Ombre',
  Paisley = 'Paisley',
  Plaid = 'Plaid',
  PolkaDot = 'PolkaDot',
  Scroll = 'Scroll',
  SerpentineStripes = 'SerpentineStripes',
  ShepherdsCheck = 'ShepherdsCheck',
  Stripes = 'Stripes',
  Suzaani = 'Suzaani',
  Tartan = 'Tartan',
  Tattersall = 'Tattersall',
  Tribal = 'Tribal'
}

export type Payment = {
  __typename?: 'Payment';
  contactEmail: Scalars['String']['output'];
  contactId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  isVerified: Scalars['Boolean']['output'];
  paymentAmount: Scalars['Float']['output'];
  paymentCurrency: Scalars['String']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  productName?: Maybe<Scalars['String']['output']>;
  productTier: ProductTier;
  signupSource: SignupSource;
  token: Scalars['String']['output'];
  verificationHash?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['String']['output']>;
};

export type PaymentConfirmationResponse = {
  __typename?: 'PaymentConfirmationResponse';
  error?: Maybe<Scalars['String']['output']>;
  features?: Maybe<FeatureSet>;
  message: Scalars['String']['output'];
  productTier?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  accountType: Scalars['String']['output'];
  contactEmail: Scalars['String']['output'];
  contactName?: Maybe<Scalars['String']['output']>;
  features?: Maybe<FeatureSet>;
  paymentAmount: Scalars['Float']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productTier: Scalars['String']['output'];
};

export enum PaymentFrequency {
  Annually = 'Annually',
  BiAnnually = 'BiAnnually',
  Monthly = 'Monthly'
}

export type PaymentResult = {
  __typename?: 'PaymentResult';
  message: Scalars['String']['output'];
  subscriptionPlan?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
};

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  _id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  lastUpdatedBy?: Maybe<Scalars['String']['output']>;
  paymentEnabled: Scalars['Boolean']['output'];
  testMode: Scalars['Boolean']['output'];
  testModeMessage: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum PaymentStatus {
  Completed = 'completed',
  Failed = 'failed',
  Free = 'free',
  Pending = 'pending'
}

export type PaymentStatusResponse = {
  __typename?: 'PaymentStatusResponse';
  message: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  shouldRedirectToDashboard: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type PaymentVerificationResponse = {
  __typename?: 'PaymentVerificationResponse';
  error?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  payment?: Maybe<PaymentDetails>;
  status?: Maybe<Scalars['String']['output']>;
  verified: Scalars['Boolean']['output'];
};

export enum PersonalityType {
  ExtrovertBlueGold = 'ExtrovertBlueGold',
  ExtrovertBlueOrange = 'ExtrovertBlueOrange',
  ExtrovertGoldBlue = 'ExtrovertGoldBlue',
  ExtrovertGoldGreen = 'ExtrovertGoldGreen',
  ExtrovertGreenGold = 'ExtrovertGreenGold',
  ExtrovertGreenOrange = 'ExtrovertGreenOrange',
  ExtrovertOrangeBlue = 'ExtrovertOrangeBlue',
  ExtrovertOrangeGreen = 'ExtrovertOrangeGreen',
  IntrovertBlueGold = 'IntrovertBlueGold',
  IntrovertBlueOrange = 'IntrovertBlueOrange',
  IntrovertGoldBlue = 'IntrovertGoldBlue',
  IntrovertGoldGreen = 'IntrovertGoldGreen',
  IntrovertGreenGold = 'IntrovertGreenGold',
  IntrovertGreenOrange = 'IntrovertGreenOrange',
  IntrovertOrangeBlue = 'IntrovertOrangeBlue',
  IntrovertOrangeGreen = 'IntrovertOrangeGreen'
}

export enum Pets {
  LiveWithCat = 'liveWithCat',
  LiveWithDog = 'liveWithDog',
  LiveWithFishOrAquatic = 'liveWithFishOrAquatic',
  NoPets = 'noPets',
  NoPetsButComfortable = 'noPetsButComfortable'
}

export enum PoliticalAffiliation {
  Democrat = 'democrat',
  Independent = 'independent',
  None = 'none',
  Other = 'other',
  Republican = 'republican'
}

export type PopulatedBeforeAndAfterProject = {
  __typename?: 'PopulatedBeforeAndAfterProject';
  _id: Scalars['ID']['output'];
  additionalSections?: Maybe<Array<Maybe<AdditionalSection>>>;
  afterImage?: Maybe<MediaFile>;
  afterImages?: Maybe<Array<Maybe<MediaFile>>>;
  beforeImage?: Maybe<MediaFile>;
  beforeImages?: Maybe<Array<Maybe<MediaFile>>>;
  budgetRange?: Maybe<BudgetRange>;
  challenges?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<MediaFile>;
  description?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<DesignerUser>;
  featuredOnBio?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  introduction?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  projectCategory?: Maybe<ProjectCategory>;
  projectDuration?: Maybe<ProjectDuration>;
  shareToken?: Maybe<Scalars['String']['output']>;
  specialRequirements?: Maybe<Array<Maybe<SpecialRequirements>>>;
  squareFootage?: Maybe<SquareFootage>;
  storySubtitle?: Maybe<Scalars['String']['output']>;
  storyTitle?: Maybe<Scalars['String']['output']>;
  style?: Maybe<ProjectStyles>;
  wishList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PopulatedDesignBoard = {
  __typename?: 'PopulatedDesignBoard';
  _id: Scalars['ID']['output'];
  color?: Maybe<Array<Maybe<ColorFamily>>>;
  description?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<Scalars['ID']['output']>;
  featuredOnBio?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  finish?: Maybe<Array<Maybe<Finishes>>>;
  greatFor?: Maybe<GreatFor>;
  images?: Maybe<Array<Maybe<MediaFile>>>;
  name?: Maybe<Scalars['String']['output']>;
  pattern?: Maybe<Array<Maybe<Patterns>>>;
  roomType?: Maybe<Array<Maybe<ProjectCategory>>>;
  texture?: Maybe<Array<Maybe<Textures>>>;
  type?: Maybe<DesignBoardType>;
  why?: Maybe<Scalars['String']['output']>;
};

export type PopulatedDesignerApplication = {
  __typename?: 'PopulatedDesignerApplication';
  _id: Scalars['ID']['output'];
  businessGoals?: Maybe<BusinessGoals>;
  createdAt?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<DesignerUser>;
  education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  experience?: Maybe<Array<Maybe<WorkExperience>>>;
  membershipTier?: Maybe<DesignerSubscriptionType>;
  references?: Maybe<Array<Maybe<Reference>>>;
  singlePaymentItems?: Maybe<Array<Maybe<SinglePaymentItems>>>;
  status?: Maybe<DesignerApplicationSteps>;
  submittedAt?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type PopulatedDesignerBio = {
  __typename?: 'PopulatedDesignerBio';
  _id?: Maybe<Scalars['ID']['output']>;
  aboutMe?: Maybe<Scalars['String']['output']>;
  coverImage?: Maybe<MediaFile>;
  coverImagePositionX?: Maybe<Scalars['Float']['output']>;
  coverImagePositionY?: Maybe<Scalars['Float']['output']>;
  currentlyReading?: Maybe<Scalars['String']['output']>;
  designAdvice?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<DesignerUser>;
  education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  favoriteBook?: Maybe<Scalars['String']['output']>;
  favoriteMovie?: Maybe<Scalars['String']['output']>;
  favoriteMusicGenre?: Maybe<Scalars['String']['output']>;
  image?: Maybe<MediaFile>;
  reviews?: Maybe<Array<Maybe<DesignerReview>>>;
  userName?: Maybe<Scalars['String']['output']>;
  whyWorkWithMe?: Maybe<Scalars['String']['output']>;
  yearsExperience?: Maybe<Scalars['Int']['output']>;
};

export type PopulatedProjectFile = {
  __typename?: 'PopulatedProjectFile';
  _id: Scalars['ID']['output'];
  budgetRange?: Maybe<BudgetRange>;
  description?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<DesignerUser>;
  featuredOnBio?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<Maybe<MediaFile>>>;
  name?: Maybe<Scalars['String']['output']>;
  projectCategory?: Maybe<ProjectCategory>;
  projectDuration?: Maybe<ProjectDuration>;
  projectStyle?: Maybe<ProjectStyles>;
  specialRequirements?: Maybe<Array<Maybe<SpecialRequirements>>>;
  squareFootage?: Maybe<SquareFootage>;
  style?: Maybe<ProjectStyles>;
};

export enum PresentationType {
  Boards = 'boards',
  ThreeD = 'threeD',
  TwoD = 'twoD',
  Virtual = 'virtual'
}

export type ProductFeatures = {
  __typename?: 'ProductFeatures';
  billingCycle: BillingCycle;
  createdAt?: Maybe<Scalars['String']['output']>;
  features: FeatureSet;
  id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  productName: Scalars['String']['output'];
  productTier: ProductTier;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum ProductTier {
  Basic = 'basic',
  Guild = 'guild',
  GuildPlus = 'guild_plus'
}

export type ProfileSocialPreferences = {
  __typename?: 'ProfileSocialPreferences';
  lgbtqPositive?: Maybe<Scalars['Boolean']['output']>;
  minorityOwned?: Maybe<Scalars['String']['output']>;
  otherPoliticalAffiliation?: Maybe<Scalars['String']['output']>;
  pets?: Maybe<Pets>;
  politicalAffiliation?: Maybe<PoliticalAffiliation>;
  preferSamePolitics?: Maybe<Scalars['Boolean']['output']>;
  preferToWorkWithRace?: Maybe<Scalars['String']['output']>;
  pronouns?: Maybe<Pronouns>;
  womenOwned?: Maybe<Scalars['Boolean']['output']>;
};

export type ProfileSocialPreferencesInput = {
  lgbtqPositive?: InputMaybe<Scalars['Boolean']['input']>;
  minorityOwned?: InputMaybe<Scalars['String']['input']>;
  otherPoliticalAffiliation?: InputMaybe<Scalars['String']['input']>;
  pets?: InputMaybe<Pets>;
  politicalAffiliation?: InputMaybe<PoliticalAffiliation>;
  preferSamePolitics?: InputMaybe<Scalars['Boolean']['input']>;
  preferToWorkWithRace?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Pronouns>;
  womenOwned?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProjectCategory {
  AntiqueSelection = 'AntiqueSelection',
  ArtSelection = 'ArtSelection',
  BasementDesign = 'BasementDesign',
  ColorConsulting = 'ColorConsulting',
  ConstructionRemodel = 'ConstructionRemodel',
  DiningRoomDesign = 'DiningRoomDesign',
  EntryDesign = 'EntryDesign',
  EventAndHolidayDecor = 'EventAndHolidayDecor',
  FamilyRoom = 'FamilyRoom',
  FullHomeDesign = 'FullHomeDesign',
  FurnitureSelection = 'FurnitureSelection',
  GuestBedroomDesign = 'GuestBedroomDesign',
  HomeOffice = 'HomeOffice',
  HomeStaging = 'HomeStaging',
  KidsBedroom = 'KidsBedroom',
  KitchenDesign = 'KitchenDesign',
  LightingDesign = 'LightingDesign',
  LivingRoomDesign = 'LivingRoomDesign',
  MudroomDesign = 'MudroomDesign',
  Other = 'Other',
  OtherBathroomDesign = 'OtherBathroomDesign',
  OutdoorSpaceDesign = 'OutdoorSpaceDesign',
  PrimaryBathroomDesign = 'PrimaryBathroomDesign',
  PrimaryBedroomDesign = 'PrimaryBedroomDesign',
  ProjectManagementDesign = 'ProjectManagementDesign',
  SpacePlanning = 'SpacePlanning'
}

export type ProjectCategoryRanking = {
  __typename?: 'ProjectCategoryRanking';
  category?: Maybe<ProjectCategory>;
  ranking?: Maybe<Scalars['Int']['output']>;
};

export type ProjectCategoryRankingInput = {
  category?: InputMaybe<ProjectCategory>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
};

export enum ProjectDuration {
  FourToSixMonths = 'FourToSixMonths',
  MoreThanAYear = 'MoreThanAYear',
  OneMonth = 'OneMonth',
  SeventToTwelveMonths = 'SeventToTwelveMonths',
  ThreeMonths = 'ThreeMonths',
  TwoMonths = 'TwoMonths'
}

export type ProjectFile = {
  __typename?: 'ProjectFile';
  _id: Scalars['ID']['output'];
  budgetRange?: Maybe<BudgetRange>;
  description?: Maybe<Scalars['String']['output']>;
  designerId?: Maybe<Scalars['ID']['output']>;
  featuredOnBio?: Maybe<Scalars['Boolean']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  images?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  projectCategory?: Maybe<ProjectCategory>;
  projectDuration?: Maybe<ProjectDuration>;
  specialRequirements?: Maybe<Array<Maybe<SpecialRequirements>>>;
  squareFootage?: Maybe<SquareFootage>;
  style?: Maybe<ProjectStyles>;
};

export enum ProjectGalleryAccess {
  Curated = 'curated',
  Limited = 'limited'
}

export enum ProjectStyles {
  ArtDeco = 'ArtDeco',
  Bohemian = 'Bohemian',
  Coastal = 'Coastal',
  Contemporary = 'Contemporary',
  Eclectic = 'Eclectic',
  Farmhouse = 'Farmhouse',
  FrenchCountry = 'FrenchCountry',
  HollywoodRegency = 'HollywoodRegency',
  Industrial = 'Industrial',
  Maximalism = 'Maximalism',
  MidCentury = 'MidCentury',
  Minimalist = 'Minimalist',
  Modern = 'Modern',
  ModernFarmhouse = 'ModernFarmhouse',
  Rustic = 'Rustic',
  Scandinavian = 'Scandinavian',
  ShabbyChic = 'ShabbyChic',
  Traditional = 'Traditional',
  Transitional = 'Transitional'
}

export enum Pronouns {
  HeHim = 'heHim',
  SheHer = 'sheHer',
  TheyThem = 'theyThem'
}

export type Query = {
  __typename?: 'Query';
  checkPaymentStatus: PaymentStatusResponse;
  getAllAdminUsers: Array<AdminUser>;
  getAllDesignerAccounts?: Maybe<Array<Maybe<PopulatedDesignerApplication>>>;
  getAllDesigners: Array<DesignerUser>;
  getAllHomeOwners: Array<HomeOwnerUser>;
  getBeforeAndAfterProject?: Maybe<PopulatedBeforeAndAfterProject>;
  getBeforeAndAfterProjectByShareToken?: Maybe<PopulatedBeforeAndAfterProject>;
  getBeforeAndAfterProjects?: Maybe<Array<Maybe<PopulatedBeforeAndAfterProject>>>;
  getCourseEnrollmentStatus?: Maybe<CourseEnrollment>;
  getDesignBoard?: Maybe<PopulatedDesignBoard>;
  getDesignBoards?: Maybe<Array<Maybe<PopulatedDesignBoard>>>;
  getDesignerApplication?: Maybe<DesignerApplication>;
  getDesignerApplicationList?: Maybe<Array<Maybe<PopulatedDesignerApplication>>>;
  getDesignerBio?: Maybe<PopulatedDesignerBio>;
  getDesignerMatchingProfile?: Maybe<DesignerMatchingProfile>;
  getDesignerOnboardingStatus?: Maybe<DesignerOnboardingStatus>;
  getDesignerProjectFiles?: Maybe<Array<Maybe<PopulatedProjectFile>>>;
  getDesignerStepStatus?: Maybe<DesignerStepStatus>;
  getHomeOwnerMatchingProfile?: Maybe<HomeOwnerMatchingProfile>;
  getHomeownerProductFeatures: Array<ProductFeatures>;
  getHomeownerStepStatus: HomeownerStepStatus;
  getPayment?: Maybe<Payment>;
  getPaymentSettings: PaymentSettings;
  getProductFeatures: Array<ProductFeatures>;
  getProductTier?: Maybe<ProductFeatures>;
  getProjectFile?: Maybe<PopulatedProjectFile>;
  getUserAccount?: Maybe<UserAccount>;
  verifyPaymentToken: PaymentVerificationResponse;
};


export type QueryCheckPaymentStatusArgs = {
  homeownerId: Scalars['String']['input'];
};


export type QueryGetBeforeAndAfterProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryGetBeforeAndAfterProjectByShareTokenArgs = {
  shareToken: Scalars['String']['input'];
};


export type QueryGetBeforeAndAfterProjectsArgs = {
  designerId: Scalars['ID']['input'];
};


export type QueryGetCourseEnrollmentStatusArgs = {
  userId: Scalars['String']['input'];
};


export type QueryGetDesignBoardArgs = {
  designBoardId: Scalars['ID']['input'];
};


export type QueryGetDesignBoardsArgs = {
  designerId: Scalars['ID']['input'];
};


export type QueryGetDesignerApplicationArgs = {
  designerId: Scalars['String']['input'];
};


export type QueryGetDesignerApplicationListArgs = {
  status?: InputMaybe<DesignerApplicationSteps>;
};


export type QueryGetDesignerBioArgs = {
  designerId: Scalars['String']['input'];
};


export type QueryGetDesignerMatchingProfileArgs = {
  designerId: Scalars['String']['input'];
};


export type QueryGetDesignerOnboardingStatusArgs = {
  designerId: Scalars['ID']['input'];
};


export type QueryGetDesignerProjectFilesArgs = {
  designerId: Scalars['ID']['input'];
};


export type QueryGetDesignerStepStatusArgs = {
  designerId: Scalars['String']['input'];
};


export type QueryGetHomeOwnerMatchingProfileArgs = {
  homeOwnerId: Scalars['String']['input'];
};


export type QueryGetHomeownerStepStatusArgs = {
  homeOwnerId: Scalars['String']['input'];
};


export type QueryGetPaymentArgs = {
  token: Scalars['String']['input'];
};


export type QueryGetProductTierArgs = {
  tier: ProductTier;
};


export type QueryGetProjectFileArgs = {
  projectFileId: Scalars['ID']['input'];
};


export type QueryGetUserAccountArgs = {
  email: Scalars['String']['input'];
};


export type QueryVerifyPaymentTokenArgs = {
  token: Scalars['String']['input'];
};

export type Reference = {
  __typename?: 'Reference';
  ProjectType?: Maybe<ReferenceProjectType>;
  businessName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ReferenceType;
  yearsKnown?: Maybe<Scalars['Int']['output']>;
};

export enum ReferenceProjectType {
  AntiqueSelection = 'AntiqueSelection',
  ArtSelection = 'ArtSelection',
  BasementDesign = 'BasementDesign',
  ColorConsulting = 'ColorConsulting',
  DiningRoomDesign = 'DiningRoomDesign',
  EntryDesign = 'EntryDesign',
  EventAndHolidayDecor = 'EventAndHolidayDecor',
  FullHomeDesign = 'FullHomeDesign',
  FurnitureSelection = 'FurnitureSelection',
  GuestBedroomDesign = 'GuestBedroomDesign',
  HomeStaging = 'HomeStaging',
  KidsBedroom = 'KidsBedroom',
  KitchenDesign = 'KitchenDesign',
  LightingDesign = 'LightingDesign',
  LivingRoomDesign = 'LivingRoomDesign',
  MudroomDesign = 'MudroomDesign',
  Other = 'Other',
  OutdoorLivingSpace = 'OutdoorLivingSpace',
  PrimaryBathroomDesign = 'PrimaryBathroomDesign',
  PrimaryBedroomDesign = 'PrimaryBedroomDesign',
  SpacePlanning = 'SpacePlanning'
}

export enum ReferenceType {
  Client = 'Client',
  Contractor = 'Contractor',
  ProductManufacturer = 'ProductManufacturer',
  ServicesVendor = 'ServicesVendor'
}

export enum SignupSource {
  FreeSignup = 'free_signup',
  Manual = 'manual',
  PaymentLink = 'payment_link'
}

export enum SinglePaymentItems {
  BioCreation = 'BioCreation',
  DesignerFilesFifteen = 'DesignerFilesFifteen',
  DesignerFilesFive = 'DesignerFilesFive',
  DesignerFilesTen = 'DesignerFilesTen',
  Financing = 'Financing'
}

export enum SpecialRequirements {
  AccessibilityForDisabilities = 'AccessibilityForDisabilities',
  ArtIntegration = 'ArtIntegration',
  CustomStorageSolutions = 'CustomStorageSolutions',
  EnvironmentallySustainableMaterials = 'EnvironmentallySustainableMaterials',
  FengShui = 'FengShui',
  HistoricalPreservationConsideration = 'HistoricalPreservationConsideration',
  HomeGym = 'HomeGym',
  Other = 'Other',
  NotApplicable = 'NotApplicable',
  OutdoorLivingConnections = 'OutdoorLivingConnections',
  PetFriendlyDesign = 'PetFriendlyDesign',
  SmartHomeIntegration = 'SmartHomeIntegration',
  SpecializedVentilationSystems = 'SpecializedVentilationSystems',
  SpecificAcousticTreatments = 'SpecificAcousticTreatments',
  UniqueLightingEffects = 'UniqueLightingEffects',
  WineCellar = 'WineCellar'
}

export enum SquareFootage {
  OverThreeThousand = 'OverThreeThousand',
  TwelveHundredToTwoThousand = 'TwelveHundredToTwoThousand',
  TwoThousandToThreeThousand = 'TwoThousandToThreeThousand',
  UnderTwelveHundred = 'UnderTwelveHundred'
}

export enum States {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Pw = 'PW',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type StrengthRanking = {
  __typename?: 'StrengthRanking';
  ranking?: Maybe<Scalars['Int']['output']>;
  strength?: Maybe<MatchingProfileStrengths>;
};

export type StrengthRankingInput = {
  ranking?: InputMaybe<Scalars['Int']['input']>;
  strength?: InputMaybe<MatchingProfileStrengths>;
};

export type StyleRanking = {
  __typename?: 'StyleRanking';
  ranking?: Maybe<Scalars['Int']['output']>;
  style?: Maybe<ProjectStyles>;
};

export type StyleRankingInput = {
  ranking?: InputMaybe<Scalars['Int']['input']>;
  style?: InputMaybe<ProjectStyles>;
};

export type SubscriptionDetails = {
  __typename?: 'SubscriptionDetails';
  amount?: Maybe<Scalars['Float']['output']>;
  billingCycle?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionType = DesignerSubscriptionWrapper | HomeOwnerSubscriptionWrapper;

export enum Textures {
  Coarse = 'Coarse',
  Contemporary = 'Contemporary',
  Earthy = 'Earthy',
  Gloss = 'Gloss',
  Hard = 'Hard',
  Matte = 'Matte',
  Natural = 'Natural',
  Plush = 'Plush',
  Rough = 'Rough',
  Smooth = 'Smooth',
  Soft = 'Soft'
}

export enum TotalRevenue {
  FiftyToSeventyFive = 'FiftyToSeventyFive',
  OneHundredFiftyToTwoHundred = 'OneHundredFiftyToTwoHundred',
  SeventyFiveToOneHundredFifty = 'SeventyFiveToOneHundredFifty',
  TwentyFiveToFifty = 'TwentyFiveToFifty',
  TwoHundredAndUp = 'TwoHundredAndUp'
}

export type UpdateApplicationGoals = {
  challenges?: InputMaybe<Scalars['String']['input']>;
  expectations?: InputMaybe<Scalars['String']['input']>;
  overview?: InputMaybe<ApplicationBusinessGoalsOverview>;
  projectCapacity?: InputMaybe<ApplicationBusinessGoalsProjectCapacity>;
};

export type UpdateDesignerApplicationInput = {
  _id: Scalars['ID']['input'];
  businessGoals?: InputMaybe<UpdateApplicationGoals>;
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  experience?: InputMaybe<Array<InputMaybe<ApplicationExperience>>>;
  membershipTier?: InputMaybe<DesignerSubscriptionType>;
  references?: InputMaybe<Array<InputMaybe<ApplicationReference>>>;
  singlePaymentItems?: InputMaybe<Array<InputMaybe<SinglePaymentItems>>>;
  status?: InputMaybe<DesignerApplicationSteps>;
};

export type UpdatePaymentSettingsInput = {
  paymentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  testMode?: InputMaybe<Scalars['Boolean']['input']>;
  testModeMessage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentStatusInput = {
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentStatus: PaymentStatus;
  token: Scalars['String']['input'];
  verificationHash?: InputMaybe<Scalars['String']['input']>;
};

export type UserAccount = {
  __typename?: 'UserAccount';
  accountStatus: AccountStatus;
  autoRenew: Scalars['Boolean']['output'];
  billingCycle?: Maybe<BillingCycle>;
  contactEmail: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  features: FeatureSet;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastLogin?: Maybe<Scalars['String']['output']>;
  paymentToken?: Maybe<Scalars['String']['output']>;
  productTier: ProductTier;
  subscriptionEndDate?: Maybe<Scalars['String']['output']>;
  subscriptionStartDate?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export enum UserAccountType {
  Admin = 'Admin',
  Designer = 'Designer',
  Homeowner = 'Homeowner'
}

export type UserFromServer = {
  __typename?: 'UserFromServer';
  accountType?: Maybe<UserAccountType>;
  aliasId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessWebsite?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipAutoRenew?: Maybe<Scalars['Boolean']['output']>;
  membershipBillingCycle?: Maybe<Scalars['String']['output']>;
  membershipNextRenewalDate?: Maybe<Scalars['String']['output']>;
  onboardingStatus?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  subscription?: Maybe<SubscriptionType>;
  subscriptionDetails?: Maybe<SubscriptionDetails>;
};

export type WorkExperience = {
  __typename?: 'WorkExperience';
  company?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['Boolean']['output']>;
  employmentType?: Maybe<EmploymentType>;
  endDate?: Maybe<Scalars['String']['output']>;
  firmSize?: Maybe<FirmSize>;
  id?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum YearsOfExperience {
  SixToNine = 'SIX_TO_NINE',
  TenPlus = 'TEN_PLUS',
  ThreeToFive = 'THREE_TO_FIVE'
}

export type HomeOwnerStyleImageSelection = {
  __typename?: 'HomeOwnerStyleImageSelection';
  imageIndex?: Maybe<Scalars['Int']['output']>;
  src?: Maybe<Scalars['String']['output']>;
  style?: Maybe<ProjectStyles>;
};

export type HomeOwnerStyleImageSelectionInput = {
  imageIndex?: InputMaybe<Scalars['Int']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
};

export type HomeOwnerStyleMatchupResult = {
  __typename?: 'HomeOwnerStyleMatchupResult';
  style1?: Maybe<ProjectStyles>;
  style2?: Maybe<ProjectStyles>;
  winner?: Maybe<ProjectStyles>;
};

export type HomeOwnerStyleMatchupResultInput = {
  style1?: InputMaybe<ProjectStyles>;
  style2?: InputMaybe<ProjectStyles>;
  winner?: InputMaybe<ProjectStyles>;
};

export type HomeOwnerInterestedStyles = {
  __typename?: 'homeOwnerInterestedStyles';
  favoriteLook?: Maybe<Scalars['Int']['output']>;
  finalSelections?: Maybe<Array<Maybe<HomeOwnerStyleImageSelection>>>;
  homeOwnerStyle?: Maybe<Array<Maybe<ProjectStyles>>>;
  matchupResults?: Maybe<Array<Maybe<HomeOwnerStyleMatchupResult>>>;
  selectedImages?: Maybe<Array<Maybe<HomeOwnerStyleImageSelection>>>;
  selectedStyles?: Maybe<Array<Maybe<ProjectStyles>>>;
};

export type HomeOwnerInterestedStylesInput = {
  favoriteLook?: InputMaybe<Scalars['Int']['input']>;
  finalSelections?: InputMaybe<Array<InputMaybe<HomeOwnerStyleImageSelectionInput>>>;
  homeOwnerStyle?: InputMaybe<Array<InputMaybe<ProjectStyles>>>;
  matchupResults?: InputMaybe<Array<InputMaybe<HomeOwnerStyleMatchupResultInput>>>;
  selectedImages?: InputMaybe<Array<InputMaybe<HomeOwnerStyleImageSelectionInput>>>;
  selectedStyles?: InputMaybe<Array<InputMaybe<ProjectStyles>>>;
};

export type UpdateHomeOwnerMatchingProfileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  stepCompletion?: InputMaybe<HomeOwnerMatchingProfileStepCompletionInput>;
  priorities?: InputMaybe<HomeOwnerPrioritiesInput>;
}>;


export type UpdateHomeOwnerMatchingProfileMutation = { __typename?: 'Mutation', updateHomeOwnerMatchingProfile?: boolean | null };

export type CreateBeforeAndAfterProjectMutationVariables = Exact<{
  designerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
  projectCategory?: InputMaybe<ProjectCategory>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>> | InputMaybe<SpecialRequirements>>;
  budgetRange?: InputMaybe<BudgetRange>;
  squareFootage?: InputMaybe<SquareFootage>;
  projectDuration?: InputMaybe<ProjectDuration>;
  beforeImage?: InputMaybe<Scalars['ID']['input']>;
  afterImage?: InputMaybe<Scalars['ID']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  storyTitle?: InputMaybe<Scalars['String']['input']>;
  storySubtitle?: InputMaybe<Scalars['String']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  challenges?: InputMaybe<Scalars['String']['input']>;
  wishList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overview?: InputMaybe<Scalars['String']['input']>;
  additionalSections?: InputMaybe<Array<InputMaybe<AdditionalSectionInput>> | InputMaybe<AdditionalSectionInput>>;
  beforeImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  afterImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CreateBeforeAndAfterProjectMutation = { __typename?: 'Mutation', createBeforeAndAfterProject?: { __typename?: 'BeforeAndAfterProject', _id: string, designerId?: string | null, name?: string | null, description?: string | null, style?: ProjectStyles | null, projectCategory?: ProjectCategory | null, specialRequirements?: Array<SpecialRequirements | null> | null, budgetRange?: BudgetRange | null, squareFootage?: SquareFootage | null, projectDuration?: ProjectDuration | null, beforeImage?: string | null, afterImage?: string | null, coverImage?: string | null, storyTitle?: string | null, storySubtitle?: string | null, introduction?: string | null, challenges?: string | null, wishList?: Array<string | null> | null, overview?: string | null, beforeImages?: Array<string | null> | null, afterImages?: Array<string | null> | null, additionalSections?: Array<{ __typename?: 'AdditionalSection', title?: string | null, content?: string | null } | null> | null } | null };

export type CreateDesignerBioMutationVariables = Exact<{
  designerId: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  whyWorkWithMe?: InputMaybe<Scalars['String']['input']>;
  designAdvice?: InputMaybe<Scalars['String']['input']>;
  favoriteMovie?: InputMaybe<Scalars['String']['input']>;
  favoriteMusicGenre?: InputMaybe<Scalars['String']['input']>;
  favoriteBook?: InputMaybe<Scalars['String']['input']>;
  currentlyReading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  coverImagePositionX?: InputMaybe<Scalars['Float']['input']>;
  coverImagePositionY?: InputMaybe<Scalars['Float']['input']>;
  reviews?: InputMaybe<Array<DesignerReviewInput> | DesignerReviewInput>;
}>;


export type CreateDesignerBioMutation = { __typename?: 'Mutation', createDesignerBio?: { __typename?: 'DesignerBio', _id?: string | null, userName?: string | null, yearsExperience?: number | null, aboutMe?: string | null, education?: Array<string | null> | null, whyWorkWithMe?: string | null, designAdvice?: string | null, favoriteMovie?: string | null, favoriteMusicGenre?: string | null, favoriteBook?: string | null, currentlyReading?: string | null, coverImage?: string | null, coverImagePositionX?: number | null, coverImagePositionY?: number | null, designerId?: string | null, image?: string | null, reviews?: Array<{ __typename?: 'DesignerReview', id: string, rating: number, text: string, author: string, location?: string | null, avatar?: string | null, source?: string | null, createdAt?: string | null } | null> | null } | null };

export type CreateNewDesignBoardMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DesignBoardType>;
  description?: InputMaybe<Scalars['String']['input']>;
  why?: InputMaybe<Scalars['String']['input']>;
  designerId?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Array<InputMaybe<ColorFamily>> | InputMaybe<ColorFamily>>;
  texture?: InputMaybe<Array<InputMaybe<Textures>> | InputMaybe<Textures>>;
  finish?: InputMaybe<Array<InputMaybe<Finishes>> | InputMaybe<Finishes>>;
  pattern?: InputMaybe<Array<InputMaybe<Patterns>> | InputMaybe<Patterns>>;
  roomType?: InputMaybe<Array<InputMaybe<ProjectCategory>> | InputMaybe<ProjectCategory>>;
  greatFor?: InputMaybe<GreatFor>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CreateNewDesignBoardMutation = { __typename?: 'Mutation', createNewDesignBoard?: { __typename?: 'DesignBoard', _id: string, name?: string | null, type?: DesignBoardType | null, description?: string | null, why?: string | null, designerId: string, color?: Array<ColorFamily | null> | null, texture?: Array<Textures | null> | null, finish?: Array<Finishes | null> | null, pattern?: Array<Patterns | null> | null, roomType?: Array<ProjectCategory | null> | null, greatFor?: GreatFor | null, images?: Array<string | null> | null } | null };

export type CreateNewProjectFileMutationVariables = Exact<{
  designerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
  projectCategory?: InputMaybe<ProjectCategory>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>> | InputMaybe<SpecialRequirements>>;
  budgetRange?: InputMaybe<BudgetRange>;
  squareFootage?: InputMaybe<SquareFootage>;
  projectDuration?: InputMaybe<ProjectDuration>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CreateNewProjectFileMutation = { __typename?: 'Mutation', createNewProjectFile?: { __typename?: 'ProjectFile', _id: string, budgetRange?: BudgetRange | null, description?: string | null, designerId?: string | null, images?: Array<string | null> | null, name?: string | null, projectCategory?: ProjectCategory | null, projectDuration?: ProjectDuration | null, specialRequirements?: Array<SpecialRequirements | null> | null, squareFootage?: SquareFootage | null, style?: ProjectStyles | null } | null };

export type DeleteBeforeAndAfterProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DeleteBeforeAndAfterProjectMutation = { __typename?: 'Mutation', deleteBeforeAndAfterProject?: boolean | null };

export type DeleteDesignBoardMutationVariables = Exact<{
  designBoardId: Scalars['ID']['input'];
}>;


export type DeleteDesignBoardMutation = { __typename?: 'Mutation', deleteDesignBoard?: boolean | null };

export type DeleteMediaFileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
}>;


export type DeleteMediaFileMutation = { __typename?: 'Mutation', deleteMediaFile?: boolean | null };

export type DeleteProjectFileMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type DeleteProjectFileMutation = { __typename?: 'Mutation', deleteProjectFile?: boolean | null };

export type GenerateBeforeAndAfterShareTokenMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GenerateBeforeAndAfterShareTokenMutation = { __typename?: 'Mutation', generateBeforeAndAfterShareToken?: { __typename?: 'BeforeAndAfterProject', _id: string, shareToken?: string | null } | null };

export type GetBeforeAndAfterProjectByShareTokenQueryVariables = Exact<{
  shareToken: Scalars['String']['input'];
}>;


export type GetBeforeAndAfterProjectByShareTokenQuery = { __typename?: 'Query', getBeforeAndAfterProjectByShareToken?: { __typename?: 'PopulatedBeforeAndAfterProject', _id: string, name?: string | null, description?: string | null, style?: ProjectStyles | null, projectCategory?: ProjectCategory | null, specialRequirements?: Array<SpecialRequirements | null> | null, budgetRange?: BudgetRange | null, squareFootage?: SquareFootage | null, projectDuration?: ProjectDuration | null, featuredOnBio?: boolean | null, storyTitle?: string | null, storySubtitle?: string | null, introduction?: string | null, challenges?: string | null, wishList?: Array<string | null> | null, overview?: string | null, shareToken?: string | null, beforeImage?: { __typename?: 'MediaFile', _id?: string | null, url?: string | null, title?: string | null, description?: string | null } | null, afterImage?: { __typename?: 'MediaFile', _id?: string | null, url?: string | null, title?: string | null, description?: string | null } | null, coverImage?: { __typename?: 'MediaFile', _id?: string | null, url?: string | null, title?: string | null, description?: string | null } | null, additionalSections?: Array<{ __typename?: 'AdditionalSection', title?: string | null, content?: string | null } | null> | null, beforeImages?: Array<{ __typename?: 'MediaFile', _id?: string | null, url?: string | null, title?: string | null, description?: string | null } | null> | null, afterImages?: Array<{ __typename?: 'MediaFile', _id?: string | null, url?: string | null, title?: string | null, description?: string | null } | null> | null, designerId?: { __typename?: 'DesignerUser', _id: string, firstName?: string | null, lastName?: string | null, email?: string | null, businessCity?: string | null, businessState?: States | null } | null } | null };

export type GetBeforeAndAfterProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetBeforeAndAfterProjectQuery = { __typename?: 'Query', getBeforeAndAfterProject?: { __typename?: 'PopulatedBeforeAndAfterProject', _id: string, budgetRange?: BudgetRange | null, description?: string | null, name?: string | null, projectCategory?: ProjectCategory | null, projectDuration?: ProjectDuration | null, specialRequirements?: Array<SpecialRequirements | null> | null, squareFootage?: SquareFootage | null, style?: ProjectStyles | null, storyTitle?: string | null, storySubtitle?: string | null, introduction?: string | null, challenges?: string | null, wishList?: Array<string | null> | null, overview?: string | null, designerId?: { __typename?: 'DesignerUser', _id: string, firstName?: string | null, lastName?: string | null, businessCity?: string | null, businessState?: States | null } | null, afterImage?: { __typename?: 'MediaFile', url?: string | null, path?: string | null, name?: string | null, _id?: string | null, title?: string | null, description?: string | null } | null, beforeImage?: { __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, title?: string | null, description?: string | null } | null, coverImage?: { __typename?: 'MediaFile', _id?: string | null, url?: string | null, name?: string | null, path?: string | null, title?: string | null, description?: string | null } | null, beforeImages?: Array<{ __typename?: 'MediaFile', _id?: string | null, url?: string | null, name?: string | null, path?: string | null, title?: string | null, description?: string | null } | null> | null, afterImages?: Array<{ __typename?: 'MediaFile', _id?: string | null, url?: string | null, name?: string | null, path?: string | null, title?: string | null, description?: string | null } | null> | null, additionalSections?: Array<{ __typename?: 'AdditionalSection', title?: string | null, content?: string | null } | null> | null } | null };

export type GetBeforeAndAfterProjectsQueryVariables = Exact<{
  designerId: Scalars['ID']['input'];
}>;


export type GetBeforeAndAfterProjectsQuery = { __typename?: 'Query', getBeforeAndAfterProjects?: Array<{ __typename?: 'PopulatedBeforeAndAfterProject', _id: string, budgetRange?: BudgetRange | null, description?: string | null, name?: string | null, projectCategory?: ProjectCategory | null, projectDuration?: ProjectDuration | null, specialRequirements?: Array<SpecialRequirements | null> | null, squareFootage?: SquareFootage | null, style?: ProjectStyles | null, featuredOnBio?: boolean | null, afterImage?: { __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, title?: string | null, description?: string | null } | null, beforeImage?: { __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, title?: string | null, description?: string | null } | null, coverImage?: { __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, title?: string | null, description?: string | null } | null } | null> | null };

export type GetCourseEnrollmentStatusQueryVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type GetCourseEnrollmentStatusQuery = { __typename?: 'Query', getCourseEnrollmentStatus?: { __typename?: 'CourseEnrollment', courseId: string, status: string, enrolledAt: string, completedAt?: string | null, score?: number | null, certificateUrl?: string | null } | null };

export type GetDesignerBioQueryVariables = Exact<{
  designerId: Scalars['String']['input'];
}>;


export type GetDesignerBioQuery = { __typename?: 'Query', getDesignerBio?: { __typename?: 'PopulatedDesignerBio', _id?: string | null, userName?: string | null, yearsExperience?: number | null, aboutMe?: string | null, education?: Array<string | null> | null, whyWorkWithMe?: string | null, designAdvice?: string | null, favoriteMovie?: string | null, favoriteMusicGenre?: string | null, favoriteBook?: string | null, currentlyReading?: string | null, coverImagePositionX?: number | null, coverImagePositionY?: number | null, image?: { __typename?: 'MediaFile', _id?: string | null, url?: string | null } | null, coverImage?: { __typename?: 'MediaFile', _id?: string | null, url?: string | null } | null, reviews?: Array<{ __typename?: 'DesignerReview', id: string, rating: number, text: string, author: string, location?: string | null, avatar?: string | null, source?: string | null, createdAt?: string | null } | null> | null, designerId?: { __typename?: 'DesignerUser', firstName?: string | null, lastName?: string | null, aliasId?: string | null, businessCity?: string | null, businessState?: States | null } | null } | null };

export type GetDesignerMatchingProfileForProfileQueryVariables = Exact<{
  designerId: Scalars['String']['input'];
}>;


export type GetDesignerMatchingProfileForProfileQuery = { __typename?: 'Query', getDesignerMatchingProfile?: { __typename?: 'DesignerMatchingProfile', _id: string, personalityType?: PersonalityType | null, expertise?: { __typename?: 'DesignerMatchingProfileExpertise', projectTypes?: Array<ProjectCategory | null> | null, experience?: Array<MatchingProfileExperience | null> | null, competency?: { __typename?: 'ExpertiseCompetency', strengths?: Array<{ __typename?: 'StrengthRanking', strength?: MatchingProfileStrengths | null, ranking?: number | null } | null> | null } | null } | null, style?: { __typename?: 'DesignerMatchingProfileStyle', knownForStyle?: ProjectStyles | null, strongStyles?: Array<ProjectStyles | null> | null } | null, workStyle?: { __typename?: 'DesignerMatchingProfileWorkStyle', minimumBudget?: BudgetRange | null, partnershipOptions?: Array<PartnershipOptions | null> | null } | null } | null };

export type GetDesignerProjectFilesQueryVariables = Exact<{
  designerId: Scalars['ID']['input'];
}>;


export type GetDesignerProjectFilesQuery = { __typename?: 'Query', getDesignerProjectFiles?: Array<{ __typename?: 'PopulatedProjectFile', _id: string, name?: string | null, description?: string | null, style?: ProjectStyles | null, projectCategory?: ProjectCategory | null, projectStyle?: ProjectStyles | null, specialRequirements?: Array<SpecialRequirements | null> | null, budgetRange?: BudgetRange | null, squareFootage?: SquareFootage | null, projectDuration?: ProjectDuration | null, featuredOnBio?: boolean | null, images?: Array<{ __typename?: 'MediaFile', _id?: string | null, url?: string | null, path?: string | null, title?: string | null, description?: string | null } | null> | null } | null> | null };

export type GetDesignBoardQueryVariables = Exact<{
  designBoardId: Scalars['ID']['input'];
}>;


export type GetDesignBoardQuery = { __typename?: 'Query', getDesignBoard?: { __typename?: 'PopulatedDesignBoard', _id: string, name?: string | null, type?: DesignBoardType | null, description?: string | null, why?: string | null, designerId?: string | null, color?: Array<ColorFamily | null> | null, texture?: Array<Textures | null> | null, finish?: Array<Finishes | null> | null, pattern?: Array<Patterns | null> | null, roomType?: Array<ProjectCategory | null> | null, greatFor?: GreatFor | null, images?: Array<{ __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, title?: string | null, description?: string | null } | null> | null } | null };

export type GetDesignBoardsQueryVariables = Exact<{
  designerId: Scalars['ID']['input'];
}>;


export type GetDesignBoardsQuery = { __typename?: 'Query', getDesignBoards?: Array<{ __typename?: 'PopulatedDesignBoard', _id: string, color?: Array<ColorFamily | null> | null, description?: string | null, designerId?: string | null, finish?: Array<Finishes | null> | null, greatFor?: GreatFor | null, name?: string | null, pattern?: Array<Patterns | null> | null, roomType?: Array<ProjectCategory | null> | null, texture?: Array<Textures | null> | null, type?: DesignBoardType | null, why?: string | null, featuredOnBio?: boolean | null, images?: Array<{ __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, title?: string | null, description?: string | null } | null> | null } | null> | null };

export type StartCourseEnrollmentMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  courseId: Scalars['String']['input'];
  crmWebhookUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type StartCourseEnrollmentMutation = { __typename?: 'Mutation', startCourseEnrollment: { __typename?: 'CourseEnrollmentResponse', success: boolean, message: string, courseUrl?: string | null } };

export type UpdateBeforeAndAfterProjectMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  designerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
  projectCategory?: InputMaybe<ProjectCategory>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>> | InputMaybe<SpecialRequirements>>;
  budgetRange?: InputMaybe<BudgetRange>;
  squareFootage?: InputMaybe<SquareFootage>;
  projectDuration?: InputMaybe<ProjectDuration>;
  beforeImage?: InputMaybe<Scalars['ID']['input']>;
  afterImage?: InputMaybe<Scalars['ID']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
  storyTitle?: InputMaybe<Scalars['String']['input']>;
  storySubtitle?: InputMaybe<Scalars['String']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  challenges?: InputMaybe<Scalars['String']['input']>;
  wishList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  overview?: InputMaybe<Scalars['String']['input']>;
  additionalSections?: InputMaybe<Array<InputMaybe<AdditionalSectionInput>> | InputMaybe<AdditionalSectionInput>>;
  beforeImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  afterImages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type UpdateBeforeAndAfterProjectMutation = { __typename?: 'Mutation', updateBeforeAndAfterProject?: { __typename?: 'BeforeAndAfterProject', _id: string, designerId?: string | null, name?: string | null, description?: string | null, style?: ProjectStyles | null, projectCategory?: ProjectCategory | null, specialRequirements?: Array<SpecialRequirements | null> | null, budgetRange?: BudgetRange | null, squareFootage?: SquareFootage | null, projectDuration?: ProjectDuration | null, beforeImage?: string | null, afterImage?: string | null, coverImage?: string | null, featuredOnBio?: boolean | null, storyTitle?: string | null, storySubtitle?: string | null, introduction?: string | null, challenges?: string | null, wishList?: Array<string | null> | null, overview?: string | null, beforeImages?: Array<string | null> | null, afterImages?: Array<string | null> | null, additionalSections?: Array<{ __typename?: 'AdditionalSection', title?: string | null, content?: string | null } | null> | null } | null };

export type UpdateDesignerBioMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
  aboutMe?: InputMaybe<Scalars['String']['input']>;
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  whyWorkWithMe?: InputMaybe<Scalars['String']['input']>;
  designAdvice?: InputMaybe<Scalars['String']['input']>;
  favoriteMovie?: InputMaybe<Scalars['String']['input']>;
  favoriteMusicGenre?: InputMaybe<Scalars['String']['input']>;
  favoriteBook?: InputMaybe<Scalars['String']['input']>;
  currentlyReading?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  coverImage?: InputMaybe<Scalars['ID']['input']>;
  coverImagePositionX?: InputMaybe<Scalars['Float']['input']>;
  coverImagePositionY?: InputMaybe<Scalars['Float']['input']>;
  reviews?: InputMaybe<Array<DesignerReviewInput> | DesignerReviewInput>;
}>;


export type UpdateDesignerBioMutation = { __typename?: 'Mutation', updateDesignerBio?: { __typename?: 'DesignerBio', aboutMe?: string | null, designAdvice?: string | null, designerId?: string | null, education?: Array<string | null> | null, userName?: string | null, whyWorkWithMe?: string | null, yearsExperience?: number | null, favoriteMovie?: string | null, favoriteMusicGenre?: string | null, favoriteBook?: string | null, currentlyReading?: string | null, _id?: string | null, image?: string | null, coverImage?: string | null, coverImagePositionX?: number | null, coverImagePositionY?: number | null, reviews?: Array<{ __typename?: 'DesignerReview', id: string, rating: number, text: string, author: string, location?: string | null, avatar?: string | null, source?: string | null, createdAt?: string | null } | null> | null } | null };

export type UpdateMediaFileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateMediaFileMutation = { __typename?: 'Mutation', updateMediaFile?: { __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, userId?: string | null, title?: string | null, description?: string | null } | null };

export type UpdateDesignBoardMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  designerId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<DesignBoardType>;
  description?: InputMaybe<Scalars['String']['input']>;
  why?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Array<InputMaybe<ColorFamily>> | InputMaybe<ColorFamily>>;
  texture?: InputMaybe<Array<InputMaybe<Textures>> | InputMaybe<Textures>>;
  finish?: InputMaybe<Array<InputMaybe<Finishes>> | InputMaybe<Finishes>>;
  pattern?: InputMaybe<Array<InputMaybe<Patterns>> | InputMaybe<Patterns>>;
  roomType?: InputMaybe<Array<InputMaybe<ProjectCategory>> | InputMaybe<ProjectCategory>>;
  greatFor?: InputMaybe<GreatFor>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateDesignBoardMutation = { __typename?: 'Mutation', updateDesignBoard?: { __typename?: 'DesignBoard', _id: string, color?: Array<ColorFamily | null> | null, description?: string | null, designerId: string, finish?: Array<Finishes | null> | null, greatFor?: GreatFor | null, images?: Array<string | null> | null, name?: string | null, pattern?: Array<Patterns | null> | null, roomType?: Array<ProjectCategory | null> | null, texture?: Array<Textures | null> | null, type?: DesignBoardType | null, why?: string | null, featuredOnBio?: boolean | null } | null };

export type UpdateProjectFileMutationVariables = Exact<{
  _id: Scalars['ID']['input'];
  designerId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  style?: InputMaybe<ProjectStyles>;
  projectCategory?: InputMaybe<ProjectCategory>;
  specialRequirements?: InputMaybe<Array<InputMaybe<SpecialRequirements>> | InputMaybe<SpecialRequirements>>;
  budgetRange?: InputMaybe<BudgetRange>;
  squareFootage?: InputMaybe<SquareFootage>;
  projectDuration?: InputMaybe<ProjectDuration>;
  images?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  featuredOnBio?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateProjectFileMutation = { __typename?: 'Mutation', updateProjectFile?: { __typename?: 'ProjectFile', _id: string, name?: string | null, description?: string | null, style?: ProjectStyles | null, projectCategory?: ProjectCategory | null, specialRequirements?: Array<SpecialRequirements | null> | null, budgetRange?: BudgetRange | null, squareFootage?: SquareFootage | null, projectDuration?: ProjectDuration | null, images?: Array<string | null> | null, featuredOnBio?: boolean | null } | null };

export type UploadMediaFileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UploadMediaFileMutation = { __typename?: 'Mutation', uploadMediaFile?: { __typename?: 'MediaFile', _id?: string | null, name?: string | null, path?: string | null, url?: string | null, userId?: string | null, title?: string | null, description?: string | null } | null };

export type GetDesignerOnboardingStatusQueryVariables = Exact<{
  designerId: Scalars['ID']['input'];
}>;


export type GetDesignerOnboardingStatusQuery = { __typename?: 'Query', getDesignerOnboardingStatus?: { __typename?: 'DesignerOnboardingStatus', bioComplete?: boolean | null, designFilesComplete?: boolean | null, matchingProfileComplete?: boolean | null } | null };

export type GetPaymentSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentSettingsQuery = { __typename?: 'Query', getPaymentSettings: { __typename?: 'PaymentSettings', _id: string, paymentEnabled: boolean, testMode: boolean, testModeMessage: string, lastUpdatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } };

export type UpdatePaymentSettingsMutationVariables = Exact<{
  input: UpdatePaymentSettingsInput;
}>;


export type UpdatePaymentSettingsMutation = { __typename?: 'Mutation', updatePaymentSettings: { __typename?: 'PaymentSettings', _id: string, paymentEnabled: boolean, testMode: boolean, testModeMessage: string, lastUpdatedBy?: string | null, createdAt?: string | null, updatedAt?: string | null } };

export type ProcessPaymentMutationVariables = Exact<{
  opaqueDataDescriptor: Scalars['String']['input'];
  opaqueDataValue: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  email: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  billingInfo: BillingInfoInput;
  homeownerId: Scalars['ID']['input'];
}>;


export type ProcessPaymentMutation = { __typename?: 'Mutation', processPayment?: { __typename?: 'PaymentResult', success: boolean, transactionId?: string | null, message: string, subscriptionPlan?: string | null } | null };

export type GetAuthorizeNetTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  planName: Scalars['String']['input'];
}>;


export type GetAuthorizeNetTokenMutation = { __typename?: 'Mutation', getAuthorizeNetToken: string };

export type UpdatePaymentStatusMutationVariables = Exact<{
  input: UpdatePaymentStatusInput;
}>;


export type UpdatePaymentStatusMutation = { __typename?: 'Mutation', updatePaymentStatus: { __typename?: 'Payment', id: string, token: string, paymentStatus?: PaymentStatus | null, paymentAmount: number, productTier: ProductTier, contactEmail: string } };

export type UpdateOnboardingStatusMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateOnboardingStatusMutation = { __typename?: 'Mutation', updateOnboardingStatus?: boolean | null };
